<template>
  <loading :active="releaseType"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="true"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots"
            :style="style">
            <!-- <div class="text-center text-blue-50 text-4xl" style="background-color:red;word-wrap:break-word; width:300px;">建立關鍵字...</div>
            <div class="w-2/4" style="background-color:blue;display: flex; justify-content: center; align-items: center; width:300px; ">
              <div style="margin: auto"> -->
                <!-- <circle-progress :percent="releasePercent" :show-percent="true" :class="'text-blue-50 text-4xl'"/> -->
                <div id="myItem5" class="ldBar label-center" data-type="fill" data-img="https://dev-private.autoturn.net/autoturn_logo_v04.svg" style="width:300px;height:300px;" ></div>
              <!-- </div>
            </div> -->
  </loading>
  <loading :active="allPageLoading"
          :can-cancel="true"
          :on-cancel="onCancel"
          :is-full-page="true"
          :color="'#fff'"
          :background-color="'#000'"
          :opacity="'0.8'"
          :loader=" dots">
  </loading>
  <div class="flex-1 flex flex-col overflow-hidden mb-16">
    <loading :active="!showCampaignData"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="true"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <loading :active="releaseLoading"
              :can-cancel="true"
              :on-cancel="onCancel"
              :is-full-page="true"
              :color="'#fff'"
              :background-color="'#000'"
              :opacity="'0.8'"
              :loader=" dots">
              <div class="text-center">{{releaseText}}</div><circle-progress :percent="releasePercent" :show-percent="true"/>
    </loading>
    <Header :title="showLang[selectLang]['views']['Event']['page_name']" @childLang="useLang">
      <div class="mx-4 text-gray-700">
        {{showLang[selectLang]['views']['Event']['advertising_source']}}
      </div>
      <div class="grid grid-cols-4 border-2 rounded-md w-28 -ml-2" style="border: 2px solid rgb(32, 3, 24); color: rgb(32, 3, 24);">
        <img class="mt-0.5 ml-0.5" width="25" src="https://dev-private.autoturn.net/img/tiktok_icon.png"/>
        <div class="mx-1 text-sm leading-7">
          Tiktok
        </div>
      </div>
      <div class="mx-4 text-gray-700">
        {{showLang[selectLang]['views']['Event']['advertise_account_text']}}
      </div>
      <div class="mx-1 text-sm text-gray-400 leading-7 border-2 rounded-md px-1 -ml-2" style="border: 2px solid rgb(32, 3, 24); color: rgb(32, 3, 24);">
        {{ adaccount_name }}
      </div>
    </Header>
    <main class="flex overflow-x-hidden bg-gray-200">
      <div class="w-1/5 mx-auto p-4">
        <div class="w-full rounded-xl bg-white p-4" :style="{height: `520px`}">
          <div v-show="false" class="h-16">
            <span v-if="!isEdit" class="h-16 break-all" @click="campaignNameEdit(true)">{{campaign_name}}</span>
            <span v-if="!isEdit && campaign_name == ''" class="h-16 text-gray-400 break-all" @click="campaignNameEdit(true)">{{showLang[selectLang]['views']['Event']['campaign_name_text']}}</span>
            <textarea v-if="isEdit" id="campaignName" class="w-full border p-1" v-model="campaign_name" @blur="campaignNameEdit(false)"></textarea>
            <i class="pi pi-pencil cursor-pointer float-right" style="fontSize: 0.8rem" @click="isEdit=!isEdit"></i>
          </div>
          <hr v-show="false" class="mb-4 border-b-1 border-blueGray-200">
          <div class="space-y-4 overflow-y-auto" :style="{height: `480px`}">
            <div v-for="(item, index) in menu" :key="index">
              <div
                v-if="item.show"
                @click="getHere(item.target)"
                :class="[
                  item.open? 'text-gray-700 p-1 cursor-pointer h-8 -mb-6' : 'text-gray-300',
                  item.target === target? 'bg-gray-100 rounded-xl' : ''
                ]">
                <!-- <i class="pi pi-chevron-down"></i> -->
                <i class="pi pi-chevron-down block float-left mt-1.5"></i>
                <!-- <span class="mx-2">{{ item.title }}</span> -->
                <span class="mx-2 block float-left w-36 break-words">{{ item.title }}</span>
                <i class="pi pi-lock float-right" v-if="!item.open"></i>
              </div>
              <div class="space-y-2 ml-4 my-2 mt-7" v-if="item.open">
                <div
                  class="text-gray-700 cursor-pointer ml-1"
                  @click="getHere(item.target)"
                  v-for="(sub, idx) in item.submenu" :key="idx">
                  <span v-if="sub.show" class="mx-2 block w-40 break-words">{{ sub.title }}</span>
                  <i class="pi pi-check-circle float-right" v-if="sub.checked"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="edit_content" ref="scrollcontent" class="w-4/5 mx-auto p-4 overflow-y-auto">
        <div v-show="target == 1">
          <CampaignName v-bind:editPage="cancelEdit" v-model:viewDatalist="campaign_name" @childCampaignName="campaignData" v-bind:lang="showLang[selectLang]" />
          <MarketingMethod v-bind:editPage="cancelEdit" v-model:viewDatalist="methodData" v-bind:goalsObjective="getGoalsObjective" v-bind:currencyList="currencyData" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childTargetKW="methodTargetKW" @childTargetDM="methodTargetDM" @childTargetLA="methodTargetLA" @childTargetCF="methodTargetCF" @childTargetAD="methodTargetAD" @childBudgetKWTotal="methodBudgetKWTotal" />
          <KeywordMix v-bind:editPage="cancelEdit" v-bind:targetKW="showTargetKW" v-bind:viewDatalist="keywordData" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" v-bind:returnKeywordsList="returnKeywordsList" v-bind:noTiktokData="noTiktokStatus" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childKeywordUrl="keywordUrl" @childSelectedCategories="childSelectedCategories" />
          <AdvertisingMix v-if="false" v-bind:showAdvertisingMix="showAdvertisingMix" v-bind:editPage="cancelEdit" v-bind:viewDatalist="lookData" v-bind:adaccountId="adaccount_id" v-bind:pixelId="formPixelId" v-bind:productUrl="productUrl" v-bind:lang="showLang[selectLang]" />
          <ConfidentialAudience v-if="false" v-bind:showMarketingDate="showMarketingDate" v-bind:editPage="cancelEdit" v-bind:viewDatalist="dateData" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" />
          <MarketingDate v-bind:showMarketingDate="showMarketingDate" v-bind:editPage="cancelEdit" v-bind:viewDatalist="dateData" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" v-bind:efficientAi="efficientAi" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childGapTime="dateGapTime" @childEndTime="dateEndTime" @childUseEndDate="dateUseEndDate" />
        </div>
        <!-- <div v-show="target == 2">
          <KeywordMix v-if="showTargetKW || showTargetLA" v-bind:editPage="cancelEdit" v-bind:targetKW="showTargetKW" v-bind:viewDatalist="keywordData" @childKeywordUrl="keywordUrl" />
          <AdvertisingMix v-if="showTargetLA" v-bind:showAdvertisingMix="showAdvertisingMix" v-bind:editPage="cancelEdit" v-bind:viewDatalist="lookData" v-bind:adaccountId="adaccount_id" v-bind:pageId="formPageId" v-bind:productUrl="productUrl" />
        </div> -->
        <div v-show="target == 2">
          <GoalsAndBudget v-bind:showGoalsAndBudget="showGoalsAndBudget" v-bind:editPage="cancelEdit" v-bind:viewDatalist="goalsData" v-bind:getDate="returnGapTime" v-bind:budgetKWTotal="budgetKW" v-bind:useEndDate="returnUseEndDate" v-bind:formMinAddition="updateMinAddition" v-bind:currencyList="currencyData" v-bind:lang="showLang[selectLang]" v-bind:useLang="selectLang" v-bind:youtubeClose="youtubeClose" v-bind:efficientAi="efficientAi" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childObjective="goalsObjective" @childObjectiveOption="objectiveOption"/>
          <Regions v-bind:editPage="cancelEdit" v-bind:viewDatalist="regionsData" v-bind:targetDM="showTargetDM" v-model:selectCountries="selectCountries" v-model:selectLangs="selectLangs" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" v-bind:efficientAi="efficientAi" @checkClose="changeYoutubeType" @childYoutube="childYoutube" />
          <Relationship v-bind:showRelationship="showRelationship" v-bind:editPage="cancelEdit" v-bind:viewDatalist="exAudiencesData" v-bind:campaignId="campaign_id" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" />
        </div>
        <div v-show="target == 3">
          <PositionAndDevice v-bind:editPage="cancelEdit" v-bind:viewDatalist="pdData" v-bind:keywordViewDatalist="keywordData" v-bind:autoPublisher="auto_publisher" v-bind:publisherPlatforms="publisher_platforms" v-bind:keywordsSelectedList="keywordsSelectedCategories" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childReturnKeywords="childReturnKeywords" @childNoTiktok="childNoTiktok"/>
          <Identity v-bind:showIdentity="showIdentity" v-bind:editPage="cancelEdit" v-bind:viewDatalist="idData" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childPageId="eventPageId" />
          <Material v-if="showMaterial" v-bind:editPage="cancelEdit" v-bind:viewDatalist="postData" v-bind:pageId="formPageId" v-bind:goalsObjective="getGoalsObjective" v-bind:campaignId="campaign_id" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" v-bind:efficientAi="efficientAi" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childActiveScroll="activeScroll" />
          <AdvertisingMaterial v-bind:editPage="cancelEdit" v-model:viewDatalist="adMaterialDataNew" v-bind:pageId="formPageId" v-bind:goalsObjective="getGoalsObjective" v-bind:changeFormId="changeFormId" v-bind:changeMessageId="changeMessageId" v-bind:lang="showLang[selectLang]" @childFormId="eventFormId" @childMessageId="eventMessageId" @childContent="adMaterialContent" :style="showAdvertisingMaterial ? '' : 'display:none;'" />
          <Form v-if="false" v-bind:editPage="cancelEdit" v-bind:viewDatalist="idData" v-bind:pageId="formPageId" v-bind:firstFormId="first_form_id" v-bind:formStatus="form_status" v-bind:formId="formId" v-bind:useTeachDetail="use_teach_detail" v-bind:selectLang="selectLang" v-bind:lang="showLang[selectLang]" @childChangeFormId="formChangeFormId" />
          <Msg v-if="false" v-bind:editPage="cancelEdit" v-bind:viewDatalist="idData" v-bind:pageId="formPageId" v-bind:firstMessageId="first_message_id" v-bind:messageStatus="message_status" v-bind:messageId="messageId" v-bind:useTeachDetail="use_teach_detail" v-bind:lang="showLang[selectLang]" @childChangeMessageId="formChangeMessageId" />
        </div>
      </div>
    </main>
    <footer class="block bg-white fixed w-full bottom-0">
      <div class="h-1 bg-green-700 progressbar" style="width:20%" :style="{width: `${process}%`}"></div>
      <div class="mx-auto pl-8 pr-28 py-4">
        <div class="flex flex-wrap items-center md:justify-between justify-center">
          <div class="border-gray-400 space-x-2">
            <button
              class="bg-blue-600 hover:bg-blue-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-white transition duration-500 ease-in-out border-2 border-blue-400"
              @click="form_update()"
              >{{showLang[selectLang]['views']['Event']['save_button']}}</button>
            <button
              v-if="this.db_writing_status == 'draft' && this.db_status == 'N'"
              class="bg-yellow-300 hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-blue-800 transition duration-500 ease-in-out border-2 border-yellow-400"
              @click="release()"
              >{{showLang[selectLang]['views']['Event']['release_button']}}</button>
          </div>
          <div class="border-gray-400 space-x-2">
            <span>{{showLang[selectLang]['views']['Event']['process_text_a']}} {{process}} % {{showLang[selectLang]['views']['Event']['process_text_b']}}</span>
          </div>
          <div class="border-gray-400 space-x-2 mr-16">
            <button
              v-if="this.target != 1"
              class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
              @click="prev()"
              :disabled="process <= 0"
            >{{showLang[selectLang]['views']['Event']['prev_text']}}</button>
            <button
              class="hover:bg-green-200 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-green-400 border-2 bg-green-400"
              @click="next()"
            >{{showLang[selectLang]['views']['Event']['next_text']}}</button>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import CampaignName from '@/components/TikTokEvent/CampaignName.vue'
  import MarketingMethod from '@/components/TikTokEvent/MarketingMethod.vue'
  import MarketingDate from '@/components/TikTokEvent/MarketingDate.vue'
  import ConfidentialAudience from '@/components/TikTokEvent/ConfidentialAudience.vue'
  import KeywordMix from '@/components/TikTokEvent/KeywordMix.vue'
  import AdvertisingMix from '@/components/TikTokEvent/AdvertisingMix.vue'
  import GoalsAndBudget from '@/components/TikTokEvent/GoalsAndBudget.vue'
  import Regions from '@/components/TikTokEvent/Regions.vue'
  import Identity from '@/components/TikTokEvent/Identity.vue'
  import Relationship from '@/components/TikTokEvent/Relationship.vue'
  import PositionAndDevice from '@/components/TikTokEvent/PositionAndDevice.vue'
  import Material from '@/components/TikTokEvent/Material.vue'
  import AdvertisingMaterial from '@/components/TikTokEvent/AdvertisingMaterial.vue'
  import Form from '@/views/Form.vue'
  import Msg from '@/views/Msg.vue'
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import CircleProgress from "vue3-circle-progress";
  import axios from 'axios'
  import Qs from 'qs'
  import lang from '@/language/tiktok_lang.json'

  export default {
    name: 'Home',
    components: {
      Header,
      CampaignName,
      MarketingMethod,
      MarketingDate,
      ConfidentialAudience,
      KeywordMix,
      AdvertisingMix,
      GoalsAndBudget,
      Regions,
      Identity,
      Relationship,
      PositionAndDevice,
      Material,
      AdvertisingMaterial,
      Form,
      Msg,
      Loading,
      CircleProgress
    },
    data() {
      return {
        selectLang: 'zh-TW',
        showLang: lang,
        use_teach_detail: false, // <!-- 新手教學 -->
        showCampaignData: false,
        showMarketingDate: true,
        showAdvertisingMix: 'true_0000',
        showGoalsAndBudget: true,
        showRelationship: true,
        showIdentity: true,
        db_writing_status: 'key',
        db_status: 'N',
        display: false,
        cancelEdit: false,
        process: 0,
        showTargetKW: true,
        showTargetDM: true,
        showTargetLA: true,
        showTargetCF: true,
        returnGapTime: null,
        returnEndTime: null,
        returnUseEndDate: null,
        budgetKW:null,
        updateMinAddition: 0,
        getGoalsObjective: null,
        showMaterial:true,
        showAdvertisingMaterial:true,
        showForm:true,
        showMsg:true,
        isEdit: false,
        campaign_id: null,
        campaign_name: null,
        advertiser_id: null,
        productUrl: null,
        adaccount_name: null,
        target: 1,
        formPixelId: null,
        formPageId: null,
        formId: null,
        messageId: null,
        changeFormId: null,
        changeMessageId: null,
        menu: [],
        Budget_KW_result: null,
        total_budget: null,
        keywordsSelectedCategories:{},
        returnKeywordsList: {},
        noTiktokStatus: false,
        currencyData: {
                      currency: '',
                      currency_name: null,
                      currency_symbol: null,
                      currency_min_price: null,
                      currency_video_min_price: null,
                      currency_suggest_price: null,
                      currency_remarketing_price: null
                    },
        methodData: {
                    Target_KW:null,
                    Budget_KW:null,
                    Target_DM:null,
                    Budget_DM:null,
                    Target_LA:null,
                    Budget_LA:null,
                    Target_RT:null,
                    Budget_RT:null,
                    use_similar_audience_status:0,
                    use_confldential_audience_status:0,
                    Target_CF:null,
                    Budget_CF:null,
                    Target_AD:null,
                    Budget_AD_min:null,
                    Budget_AD_max:null,
                    retargeting:null,
                    daily_budget:null
                  },
        dateData: {
                    start_date:null,
                    end_date:null,
                    use_end_date:null,
                  },
        keywordData: {
                      product_url:null,
                      keywords:null,
                      base_keyword_list: [],
                      select_keywords:null,
                      creator_action_categories: [],
                      interest_categories: [],
                      video_action_categories: [],
                      interest_keywords: [],
                      hashtags: [],
                      selected_keywords_list: {}
                    },
        lookData: {
                    default_lookalikes:null,
                    custom_lookalikes:null,
                    custom_lookalikes_selected:null,
                    default_lookalikes_list:null,
                    custom_lookalikes_list:null
                  },
        goalsData: {
                    campaign_objective:null,
                    objective_option:null,
                    objective_list:null,
                    product_catalog_list:null,
                    product_set_list:null,
                    optimization_action:null,
                    optimization_goal:null,
                    product_catalog_id:null,
                    product_set_id:null,
                    pixel_id:null,
                    pixel_event:null,
                    conversion_domain:null,
                    domain_list:null,
                    useAppEvent: false,
                    appItemsSelected: null,
                    appItemsList: [],
                    effect:null,
                    currency_video_min_price:null,
                    form_addition:null,
                    use_addition:null,
                    risk_automatic:null,
                    risk_index:null,
                    risk_level_list:null,
                    risk_level:null
                  },
        regionsData: {
                      location_types:null,
                      locations:null,
                      locales:null,
                      gender:null,
                      age_min:null,
                      age_max:null
                    },
        selectCountries: null,
        selectLangs: null,
        exAudiencesData: {
                      excluded_audiences:null,
                      default_excluded_audiences:null,
                      custom_excluded_audiences:null,
                      custom_excluded_audiences_selected:null,
                    },
        pdData: {
                  auto_publisher:null,
                  publisher_platforms:null,
                  publisher_platforms_list:null,
                  device_platforms: null,
                  user_os:null,
                  user_os_list:null,
                },
        auto_publisher: null,
        publisher_platforms: null,
        idData: {
                  page_id:null,
                  ig_id:null,
                  ig_username:null,
                  adpages_list:null,
                  ig_list:null,
                },
        postData: {
                  page_id:null,
                  special_ad_category:null,
                  disabled_creative_optimize:false,
                  creative_optimize:false,
                  select_article:null,
                  db_select_article:null,
                  select_creatives:null,
                  db_select_creatives:null,
                  select_creatives_message:null,
                  db_select_creatives_message:null,
                  select_creatives_adset_ads:null,
                  db_select_creatives_adset_ads:null,
                },
        adMaterialData: {
                          disabled_creative_optimize:false,
                          creative_optimize:false,
                          creative_array:null,
                        },
        tmpAdMaterialDataNew:{
                            disabled_creative_optimize:false,
                            creative_optimize:false,
                            creative_array:null,
                          },
        adMaterialDataNew:{
                            disabled_creative_optimize:false,
                            creative_optimize:false,
                            creative_array:null,
                          },
        formData: {
                    pageId: null,
                    formId: null
                  },
        msgData: {
                    pageId: null,
                    msgId: null
                  },
        first_form_id: null,
        form_status: null,
        first_message_id: null,
        message_status: null,
        AdvertisingMaterialStatus: undefined,
        releaseType: true,
        efficientAi: null,
        style: 'z-index: -1;',
        releaseText: '發佈中...',
        releasePercent: 0,
        allPageLoading: false,
        youtubeClose: false,
      }
    },
    created() {
      // console.log('id:'+this.$route.params.id);
      // console.log('adaccount_id:'+this.$route.params.adaccount_id);
      // console.log('campaign_id:'+this.$route.params.campaign_id);

      let hash = this.$route.params.id;

      if(hash != '' && hash != null && typeof hash != 'undefined'){
        axios
          .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign.php', Qs.stringify({
            s_code: this.$route.params.id,
            advertiser_id: this.$route.params.adaccount_id,
            campaign_id: this.$route.params.campaign_id
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              this.campaign_id = this.$route.params.campaign_id
              this.campaign_name = response.data.return_data.campaign_name
              this.advertiser_id = response.data.return_data.advertiser_id
              this.adaccount_name = response.data.return_data.adaccount_name
              this.productUrl = response.data.return_data.product_url

              document.title = response.data.return_data.campaign_name+' - '+this.showLang[this.selectLang]['views']['Event']['created']['page_title']+' - AutoTurn';

              this.showTargetKW = response.data.return_data.Target_KW
              // this.showTargetLA = response.data.return_data.Target_LA
              this.showTargetLA = false

              let startTime = response.data.return_data.start_date;
              let endTime = response.data.return_data.end_date;
              let diffType = 'day';

              let gapTime = 0;

              if(startTime != '' && startTime != '0000-00-00' && startTime != null && endTime != '' && endTime != '0000-00-00' && endTime != null){
                diffType = diffType.toLowerCase();
                var sTime =new Date(startTime); //開始時間
                var eTime =new Date(endTime); //結束時間
                //作為除數的數字
                var timeType = 1;
                switch (diffType) {
                    case"second":
                        timeType =1000;
                    break;
                    case"minute":
                        timeType =1000*60;
                    break;
                    case"hour":
                        timeType =1000*3600;
                    break;
                    case"day":
                        timeType =1000*3600*24;
                    break;
                    default:
                    break;
                }
                gapTime = parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType));
              }

              this.budgetKW = response.data.return_data.Budget_KW;
              this.returnGapTime = gapTime;
              this.returnEndTime = response.data.return_data.end_date;
              this.returnUseEndDate = response.data.return_data.use_end_date;
              this.Budget_KW_result = response.data.return_data.Budget_KW_result;
              this.total_budget = response.data.return_data.total_budget;

              this.currencyData = {
                                    currency: response.data.return_data.currency,
                                    currency_name: response.data.return_data.currency_name,
                                    currency_symbol: response.data.return_data.currency_symbol,
                                    currency_min_price: response.data.return_data.currency_min_price,
                                    currency_video_min_price: response.data.return_data.currency_video_min_price,
                                    currency_suggest_price: response.data.return_data.currency_suggest_price,
                                    currency_remarketing_price: response.data.return_data.currency_remarketing_price,
                                    KW_min_price: response.data.return_data.KW_min_price,
                                    DM_min_price: response.data.return_data.DM_min_price,
                                    LA_min_price: response.data.return_data.LA_min_price,
                                    RT_min_price: response.data.return_data.RT_min_price,
                                  }

              let _tmp_Target_LA = response.data.return_data.Target_LA;
              let _tmp_Budget_LA = response.data.return_data.Budget_LA;
              // if(_tmp_Target_LA == '1'){
              //   _tmp_Target_LA = false;
              //   _tmp_Budget_LA = 0;

              //   Swal.fire(
              //               this.showLang[this.selectLang]['views']['Event']['created']['LA_swal_title'],
              //               this.showLang[this.selectLang]['views']['Event']['created']['LA_swal_text'],
              //               'warning'
              //             )
              // }

              console.log('response.data.return_data.daily_budget');
              console.log(response.data.return_data.daily_budget);

              this.methodData = {
                                  Target_KW : response.data.return_data.Target_KW,
                                  Budget_KW : response.data.return_data.Budget_KW,
                                }

              console.log('this.methodData');
              console.log(this.methodData);
              console.log('response.data.return_data.Target_LA');
              console.log(response.data.return_data.Target_LA);
              console.log('b showAdvertisingMix');
              console.log(this.showAdvertisingMix);

              if(response.data.return_data.Target_LA == '1'){

                var todayForm = new Date();
                var yearForm = todayForm.getFullYear();
                var dateForm = String(todayForm.getDate()).padStart(2, '0');
                var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                let get_value = 'false_'+yearForm + monthForm + dateForm + timeForm;

                this.showAdvertisingMix = get_value;
              }

              console.log('a showAdvertisingMix');
              console.log(this.showAdvertisingMix);

              this.dateData = {
                                start_date : response.data.return_data.start_date,
                                end_date : response.data.return_data.end_date,
                                use_end_date : response.data.return_data.use_end_date
                              }

              this.keywordData = {
                                    product_url : response.data.return_data.product_url,
                                    keywords : response.data.return_data.keywords,
                                    keyword_list : response.data.return_data.keyword_list,
                                    base_keyword_list: response.data.return_data.base_keyword_list,
                                    select_keywords : response.data.return_data.keywords,
                                    creator_action_categories: response.data.return_data.creator_action_categories,
                                    interest_categories: response.data.return_data.interest_categories,
                                    video_action_categories: response.data.return_data.video_action_categories,
                                    interest_keywords: response.data.return_data.interest_keywords,
                                    hashtags: response.data.return_data.hashtags,
                                    selected_keywords_list: response.data.return_data.selected_keywords_list,
                                  }

              this.lookData = {
                                default_lookalikes : response.data.return_data.default_lookalikes,
                                custom_lookalikes : response.data.return_data.custom_lookalikes,
                                custom_lookalikes_selected : response.data.return_data.custom_lookalikes_selected,
                                default_lookalikes_list : response.data.return_data.default_lookalikes_list,
                                custom_lookalikes_list : response.data.return_data.custom_lookalikes_list
                              }

              this.goalsData = {
                                  objective_type : response.data.return_data.objective_type,
                                  objective_option : response.data.return_data.objective_option,
                                  objective_list : response.data.return_data.objective_list,
                                  effect : response.data.return_data.effect,
                                  currency_video_min_price: response.data.return_data.currency_video_min_price,
                                  budget_increase : response.data.return_data.budget_increase,
                                  budget_switch : response.data.return_data.budget_switch,
                                  risk_automatic : response.data.return_data.risk_automatic,
                                  risk_level_list: response.data.return_data.risk_level_list,
                                  risk_level: response.data.return_data.risk_level
                                }

              console.log('this.goalsData');
              console.log(this.goalsData);

              this.regionsData = {
                                    locations_list : response.data.return_data.locations_list,
                                    locations_selected : response.data.return_data.locations_selected,
                                    locations : response.data.return_data.locations,
                                    locales : response.data.return_data.locales,
                                    locales_list : response.data.return_data.locales_list,
                                    locales_selected : response.data.return_data.locales_selected,
                                    gender : response.data.return_data.gender,
                                    age_groups : response.data.return_data.age_groups
                                  }

              this.selectCountries = response.data.return_data.locations

              this.selectLangs = response.data.return_data.locales

              axios
                .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_audiences_list.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  advertiser_id: this.$route.params.adaccount_id,
                  excluded_audiences: response.data.return_data.excluded_audiences
                }))
                .then((exResponse) => {
                  console.log('exResponse');
                  console.log(exResponse);
                  this.exAudiencesData = {
                                            excluded_audiences : response.data.return_data.excluded_audiences,
                                            excluded_audiences_list : exResponse.data.excluded_audiences_list,
                                            default_excluded_audiences : response.data.return_data.default_excluded_audiences,
                                            custom_excluded_audiences : response.data.return_data.custom_excluded_audiences,
                                            custom_excluded_audiences_selected : response.data.return_data.custom_excluded_audiences_selected,
                                          }
                });

              this.pdData = {
                              auto_publisher : response.data.return_data.auto_publisher,
                              publisher_platforms : response.data.return_data.publisher_platforms,
                              publisher_platforms_list : response.data.return_data.publisher_platforms_list,
                              placement_type : response.data.return_data.placement_type,
                              placements : response.data.return_data.placements,
                              device_platforms: response.data.return_data.device_platforms,
                              operating_systems : response.data.return_data.operating_systems,
                              user_os_list : response.data.return_data.user_os_list
                            }

              this.auto_publisher = response.data.return_data.auto_publisher
              this.publisher_platforms = response.data.return_data.publisher_platforms

              this.idData = {
                              identity_id : response.data.return_data.identity_id,
                              adpages_list : response.data.return_data.adpages_list,
                            }

              this.postData = {
                                page_id : response.data.return_data.page_id,
                                special_ad_category : response.data.return_data.special_ad_category,
                                disabled_creative_optimize : response.data.return_data.disabled_creative_optimize,
                                creative_optimize : response.data.return_data.creative_optimize,
                                creative_optimize: response.data.return_data.creative_optimize,
                                db_select_article : response.data.return_data.post_ids,
                                db_select_creatives : response.data.return_data.creatives_ids,
                                db_select_creatives_message : response.data.return_data.creatives_message_ids,
                                db_select_creatives_adset_ads : response.data.return_data.creatives_ids_adset_ads,
                              }

              // console.log(response.data.return_data.campaign_objective);
              // console.log('b this.postData');
              // console.log(this.postData);

              // if(response.data.return_data.campaign_objective == 'PRODUCT_CATALOG_SALES'){
              //   this.postData.db_select_creatives_adset_ads = response.data.return_data.creatives_ids_adset_ads;
              // } else {
              //   this.postData.db_select_creatives = response.data.return_data.creatives_ids;
              // }

              // console.log('a this.postData');
              // console.log(this.postData);

              this.adMaterialData = {
                                      disabled_creative_optimize : response.data.return_data.disabled_creative_optimize,
                                      creative_optimize: response.data.return_data.creative_optimize,
                                      creative_array : response.data.return_data.creative_array,
                                    }

              this.tmpAdMaterialDataNew = {
                                            disabled_creative_optimize : response.data.return_data.disabled_creative_optimize,
                                            creative_optimize: response.data.return_data.creative_optimize,
                                            creative_array : response.data.return_data.creative_array
                                          }

              this.formPixelId = response.data.return_data.pixel_id

              this.db_writing_status = response.data.return_data.writing_status

              this.db_status = response.data.return_data.status

              console.log('load this.adMaterialData');
              console.log(this.adMaterialData);
              console.log('load this.tmpAdMaterialDataNew');
              console.log(this.tmpAdMaterialDataNew);

              // if(response.data.return_data.creative_array.length > 0){
              //   this.showAdvertisingMaterial = true;
              //   this.showMsg = true;
              // } else {
              //   this.showAdvertisingMaterial = false;
              //   this.showMsg = false;
              // }

              // console.log('response.data.return_data.form_addition:'+response.data.return_data.form_addition);
              // console.log('b this.goalsData:'+this.goalsData.form_addition);
              this.minAddition(response.data.return_data.form_addition, gapTime, response.data.return_data.Budget_KW, this.returnUseEndDate);
              // console.log('a this.goalsData:'+this.goalsData.form_addition);
            }

            if(response.data.status == 'login'){
              Swal.fire({
                icon: 'error',
                title: this.showLang[this.selectLang]['views']['Event']['created']['login']['swal_title'],
                text: this.showLang[this.selectLang]['views']['Event']['created']['login']['swal_text'],
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['Event']['created']['login']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  // this.allPageLoading = true
                  window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  // this.allPageLoading = true
                  window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                }
              })
            }

            this.showCampaignData = true;
          });
      } else {
        Swal.fire({
          icon: 'error',
          title: this.showLang[this.selectLang]['views']['Event']['created']['no_hash_swal_title'],
          text: this.showLang[this.selectLang]['views']['Event']['created']['no_hash_swal_text'],
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: this.showLang[this.selectLang]['views']['Event']['created']['no_hash_swal_confirm_button']
          // denyButtonText: `Don't save`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            // Swal.fire('Saved!', '', 'success')
            // this.allPageLoading = true
            window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
          } else if (result.isDenied) {
            // Swal.fire('Changes are not saved', '', 'info')
            // this.allPageLoading = true
            window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
          }
        })
      }
    },
    watch:{
      // 'formPageId': function(v){
      //   console.log('event formPageId');
      //   console.log(v);
      // },
      // 'idData.page_id': function(v){
      //   console.log('event idData.page_id');
      //   console.log(v);
      // }
      AdvertisingMaterialStatus(status) {
        // console.log('watch AdvertisingMaterialStatus');
        // console.log(status);
        if (status) {
          // console.log(status);
          this.$nextTick().then(() =>
            this.$refs.scrollcontent.scrollTo({
              top: 1505,
              behavior: 'smooth'
            })
          );
        }
      }
    },
    methods: {
      changeYoutubeType(){
        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        todayForm = yearForm + monthForm + dateForm + timeForm;

        this.youtubeClose = 'false_'+todayForm;

        console.log('eventadd changeYoutubeType');
        console.log(this.youtubeClose);
      },
      childYoutube(v){
        this.youtubeClose = v;
      },
      useLang(v){
        console.log('event methods useLang');
        console.log(v);

        if(v == '' || v == null || typeof v == 'undefined'){
          v = 'zh-TW';
        }

        this.selectLang = v

        this.$emit('childLang', v);

        console.log('this.selectLang');
        console.log(this.selectLang);
        // console.log('showLang['+v+'][msg]');
        // console.log(this.showLang[v]['msg']);

        this.menu = [
          {
            title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_0_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_1_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_2_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_5_title'], show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 1
          },
          // {
          //   title: '關鍵字與受眾',
          //   submenu: [
          //     {title: '精準興趣關鍵字', show: true, checked: false},
          //     {title: '類似受眾廣告組合', show: true, checked: false},
          //   ],
          //   open: true,
          //   show: true,
          //   target: 2
          // },
          {
            title: this.showLang[this.selectLang]['views']['Event']['menu']['step_2_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_2_submenu_1_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_2_submenu_2_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_2_submenu_3_title'], show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 2
          },
          {
            title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_submenu_1_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_submenu_2_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_submenu_3_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_submenu_4_title'], show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 3
          },
        ];
      },
      campaignData(value){
        console.log('campaignData'+value);
        this.campaign_name = value
      },
      campaignNameEdit(type){
        // console.log('campaignNameEdit');

        this.isEdit = type;

        // if(type == true){
        //   console.log('鎖定');
        //   document.getElementById("campaignName").focus();
        //   this.$refs.campaignName.focus();
        // }
      },
      minAddition(budgetAddition, day, budgetKW, useEndDate){
        // console.log('value budgetAddition:'+budgetAddition);

        // console.log('getDate budgetAddition:'+day);
        // console.log('budgetKWTotal budgetAddition:'+budgetKW);
        // console.log('useEndDate budgetAddition:'+useEndDate);

        // if(useEndDate == false){
        //   //有結束日期
        //   // console.log('有結束日期');
        //   //先算精準興趣總預算

        //   if(!isNaN(day) && day > 0){
        //     // console.log('有日期間距');
        //     var _tmp_days = day;
        //     var _tmp_total = budgetKW;
        //     // var _tmp_budget_addition = (budget_addition == '' || budget_addition == 0)?0:budget_addition/100
        //     var _tmp_interval_week = 0;
        //     var interval_week = 0;
        //     var n = 0;
        //     var html = 0;
        //     var video_min_price = this.currencyData.currency_video_min_price;
        //     var _tmp_budget_addition = video_min_price;

        //     let _test_total = 0;

        //     if(_tmp_days > 0){
        //         if(_tmp_days > 3){
        //             n = Math.round(_tmp_days/7);
        //         }
        //     }

        //     //console.log(_tmp_total+'*7');
        //     var first_week = _tmp_total*7;

        //     for(var i = 1; i < n; i++){
        //         var days_pow = i + 1;
        //         // console.log('days_pow:'+days_pow);
        //         // console.log(_tmp_total+' * Math.pow((1 + '+_tmp_budget_addition+'), '+days_pow+') * 7');

        //         //console.log('('+_tmp_total +'+ ('+days_pow+' - 1) * '+_tmp_budget_addition+') * 7');
        //         _tmp_interval_week = (parseInt(_tmp_total) + (parseInt(days_pow) - 1) * parseInt(_tmp_budget_addition)) * 7;

        //         // console.log(interval_week +'='+ interval_week +'+'+ _tmp_interval_week);
        //         interval_week = interval_week + _tmp_interval_week;
        //     }

        //     // console.log(_tmp_total + ' * Math.pow((1 + '+_tmp_budget_addition+'), '+n+') * ('+_tmp_days+' - 7 * '+n+')');

        //     //console.log('('+_tmp_total +'+'+ n +'*'+ _tmp_budget_addition+') * ('+_tmp_days +' - 7 * '+ n+')');
        //     var finish_week = (parseInt(_tmp_total) + parseInt(n) * parseInt(_tmp_budget_addition)) * (parseInt(_tmp_days) - 7 * parseInt(n));

        //     if(_tmp_days > 0 && _tmp_total > 0){
        //         // console.log('Math.round('+first_week +'+'+ interval_week +'+'+ finish_week+')');
        //         html = Math.round(parseInt(first_week) + parseInt(interval_week) + parseInt(finish_week));
        //     }

        //     _test_total = html;

        //     this.Budget_KW_result = html;

        //     //計算最低預算比率
        //     let _ratio = ((Math.ceil(((parseInt(_test_total) / (parseInt(_tmp_total) * parseInt(_tmp_days))))*100)/100 - 1)*100).toFixed(0);

        //     this.updateMinAddition = _ratio;

        //     if(parseInt(budgetAddition) < parseInt(_ratio)){
        //       // console.log('有結束日期之下，不允許小於:'+_ratio);
        //       this.goalsData.form_addition = _ratio;
        //     } else {
        //       // console.log(budgetAddition +" > "+ _ratio);
        //     }
        //   } else {
        //     // console.log('沒結束日期也沒日期間距');
        //     var _tmp_keyword_split_budget = budgetKW;
        //     var video_min_price = this.currencyData.currency_video_min_price;
        //     var single_ratio = Math.ceil((video_min_price/(parseInt(_tmp_keyword_split_budget)))*100);
        //     if(_tmp_keyword_split_budget == 0){
        //         single_ratio = 0;
        //     }

        //     this.updateMinAddition = single_ratio;

        //     if(parseInt(budgetAddition) < parseInt(single_ratio)){
        //       // console.log('沒結束日期之下，不允許小於:'+single_ratio);
        //       this.goalsData.form_addition = single_ratio;
        //     } else {
        //       // console.log(budgetAddition +" > "+ single_ratio);
        //     }
        //   }

        // } else {
        //   //沒結束日期
        //   // console.log('沒結束日期');
        //   var _tmp_keyword_split_budget = budgetKW;
        //   var video_min_price = this.currencyData.currency_video_min_price;
        //   var single_ratio = Math.ceil((video_min_price/(parseInt(_tmp_keyword_split_budget)))*100);
        //   if(_tmp_keyword_split_budget == 0){
        //       single_ratio = 0;
        //   }

        //   this.updateMinAddition = single_ratio;

        //   if(budgetAddition < single_ratio){
        //     // console.log('沒結束日期之下，不允許小於:'+single_ratio);
        //     this.goalsData.form_addition = single_ratio;
        //   } else {
        //     // console.log(budgetAddition +" > "+ single_ratio);
        //   }
        // }

        // console.log('update this.updateMinAddition:'+this.updateMinAddition);

        // return 'string form test_call';
      },
      methodTargetKW(value){
        // console.log('methods childTargetKW')
        // console.log(value);
        this.showTargetKW = value
        // this.menu[0].submenu[2].show = value

        if(value == true){
          this.minAddition(this.goalsData.form_addition, this.returnGapTime, this.budgetKW, this.returnUseEndDate);
        } else {
          this.updateMinAddition = 0;
        }

        // if(!this.menu[1].submenu[0].show && !this.menu[1].submenu[1].show){
        //   this.menu[1].show = false
        // } else {
        //   this.menu[1].show = true
        // }
      },
      methodTargetDM(value){
        // console.log('methods childTargetDM')
        // console.log(value);
        this.showTargetDM = value

        if(value == true){
          // if(this.getGoalsObjective == 'CONVERSIONS'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 65;
          // }
          // if(this.getGoalsObjective == 'LINK_CLICKS'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 64;
          // }
          // if(this.getGoalsObjective == 'POST_ENGAGEMENT'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 64;
          // }
          // if(this.getGoalsObjective == 'VIDEO_VIEWS'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 64;
          // }
          // if(this.getGoalsObjective == 'LEAD_GENERATION'){
          //   this.regionsData.age_min = 18;
          //   this.regionsData.age_max = 65;
          // }
          // if(this.getGoalsObjective == 'MESSAGES'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 64;
          // }

          this.regionsData.age_min = 18;
          this.regionsData.age_max = 65;
        }

        // console.log(this.regionsData);
      },
      methodTargetLA(value){
        console.log('methods childTargetLA')
        console.log(value);
        this.showTargetLA = value
        // this.menu[0].submenu[3].show = value

        if(value == true && this.lookData.custom_lookalikes == null){
          console.log('in');
          var todayForm = new Date();
          var yearForm = todayForm.getFullYear();
          var dateForm = String(todayForm.getDate()).padStart(2, '0');
          var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
          var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

          let get_value = 'true_'+yearForm + monthForm + dateForm + timeForm;

          this.showAdvertisingMix = get_value;
          console.log('axios showAdvertisingMix');
          console.log(this.showAdvertisingMix);

          axios
            .post('https://test.autoturn.net/inside/api/campaign_lookalikes.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
              pixel_id: this.goalsData.pixel_id,
              product_url: this.productUrl,
            }))
            .then((response) => {
              if(response.data.status == 'success'){

                this.lookData = {
                                  default_lookalikes : response.data.return_data.default_lookalikes,
                                  custom_lookalikes : response.data.return_data.custom_lookalikes,
                                  custom_lookalikes_selected : response.data.return_data.custom_lookalikes_selected,
                                  default_lookalikes_list : response.data.return_data.default_lookalikes_list,
                                  custom_lookalikes_list : response.data.return_data.custom_lookalikes_list
                                }

                var todayForm = new Date();
                var yearForm = todayForm.getFullYear();
                var dateForm = String(todayForm.getDate()).padStart(2, '0');
                var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                let get_value = 'false_'+yearForm + monthForm + dateForm + timeForm;

                this.showAdvertisingMix = get_value;
              }
            });
        }

        if(value != true && this.lookData.custom_lookalikes != null) {
          this.lookData = {
                            default_lookalikes : null,
                            custom_lookalikes : null,
                            custom_lookalikes_selected : null,
                            default_lookalikes_list : null,
                            custom_lookalikes_list : null
                          }
        }

        console.log(this.lookData);
        console.log('end showAdvertisingMix');
        console.log(this.showAdvertisingMix);

        // if(!this.menu[1].submenu[0].show && !this.menu[1].submenu[1].show){
        //   this.menu[1].show = false
        // } else {
        //   this.menu[1].show = true
        // }
      },
      methodTargetCF(value){
        this.showTargetCF = value
        // this.menu[0].submenu[4].show = value
      },
      methodTargetAD(value){
        console.log('methodTargetAD');
        console.log(value);

        this.efficientAi = value;

        this.dateData.end_date = '0000-00-00';
        console.log('this.dateData.end_date');
        console.log(this.dateData.end_date);
      },
      methodBudgetKWTotal(value){
        // console.log('methodBudgetKWTotal:'+value);
        // console.log('b this.budgetKW:'+this.budgetKW);
        this.budgetKW = value;

        if(value > 0){
          this.minAddition(this.goalsData.form_addition, this.returnGapTime, value, this.returnUseEndDate);
        }

        // console.log('a this.budgetKW:'+this.budgetKW);
      },
      dateGapTime(value){
        // console.log('dateGapTime:'+value);
        // console.log('b this.returnGapTime:'+this.returnGapTime);
        this.returnGapTime = value;

        if(value > 0){
          this.minAddition(this.goalsData.form_addition, value, this.budgetKW, this.returnUseEndDate);
        }

        // console.log('a this.returnGapTime:'+this.returnGapTime);
      },
      dateEndTime(value){
        // console.log('dateEndTime:'+value);
        // console.log('b this.returnEndTime:'+this.returnEndTime);
        this.returnEndTime = value;

        let startTime = this.dateData.start_date;
        let diffType = 'day';
        let gapTime = 0;

        if(startTime != '' && startTime != '0000-00-00' && startTime != null && value != '' && value != '0000-00-00' && value != null){
          diffType = diffType.toLowerCase();
          var sTime =new Date(startTime); //開始時間
          var eTime =new Date(value); //結束時間
          //作為除數的數字
          var timeType = 1;
          switch (diffType) {
              case"second":
                  timeType =1000;
              break;
              case"minute":
                  timeType =1000*60;
              break;
              case"hour":
                  timeType =1000*3600;
              break;
              case"day":
                  timeType =1000*3600*24;
              break;
              default:
              break;
          }
          gapTime = parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType));
        }

        this.returnGapTime = gapTime;

        this.minAddition(this.goalsData.form_addition, gapTime, this.budgetKW, this.returnUseEndDate);

        // console.log('a this.returnEndTime:'+this.returnEndTime);
      },
      dateUseEndDate(value){
        // console.log('dateUseEndDate:'+value);
        // console.log('b this.returnUseEndDate:'+this.returnUseEndDate);
        this.returnUseEndDate = value

        this.minAddition(this.goalsData.form_addition, this.returnGapTime, this.budgetKW, value);

        // console.log('a this.returnUseEndDate:'+this.returnUseEndDate);
      },
      goalsObjective(value){
        console.log('event goalsObjective')
        console.log(value);
        console.log('this.goalsData');
        console.log(this.goalsData);

        // this.getGoalsObjective = value

        // if(this.showTargetDM == true){
        //   if(value == 'CONVERSIONS'){
        //     this.regionsData.age_min = 18;
        //     this.regionsData.age_max = 65;
        //   }
        //   if(value == 'LINK_CLICKS'){
        //     this.regionsData.age_min = 18;
        //     this.regionsData.age_max = 64;
        //   }
        //   if(value == 'POST_ENGAGEMENT'){
        //     this.regionsData.age_min = 18;
        //     this.regionsData.age_max = 64;
        //   }
        //   if(value == 'VIDEO_VIEWS'){
        //     this.regionsData.age_min = 18;
        //     this.regionsData.age_max = 64;
        //   }
        //   if(value == 'LEAD_GENERATION'){
        //     this.regionsData.age_min = 18;
        //     this.regionsData.age_max = 65;
        //   }
        //   if(value == 'MESSAGES'){
        //     this.regionsData.age_min = 18;
        //     this.regionsData.age_max = 64;
        //   }
        // }

        // if(value == 'CONVERSIONS'){
        //   this.showMaterial = true;
        //   this.showAdvertisingMaterial = false;
        //   this.showForm = false;
        //   this.showMsg = false;

        //   this.adMaterialData.creative_array = []
        // }
        // if(value == 'LINK_CLICKS'){
        //   this.showMaterial = true;
        //   this.showAdvertisingMaterial = false;
        //   this.showForm = false;
        //   this.showMsg = false;

        //   this.adMaterialData.creative_array = []
        // }
        // if(value == 'POST_ENGAGEMENT'){
        //   this.showMaterial = true;
        //   this.showAdvertisingMaterial = false;
        //   this.showForm = false;
        //   this.showMsg = false;

        //   this.adMaterialData.creative_array = []
        // }
        // if(value == 'VIDEO_VIEWS'){
        //   this.showMaterial = true;
        //   this.showAdvertisingMaterial = false;
        //   this.showForm = false;
        //   this.showMsg = false;

        //   this.adMaterialData.creative_array = []
        // }
        // if(value == 'LEAD_GENERATION'){
        //   this.showMaterial = false;
        //   this.showAdvertisingMaterial = true;
        //   this.showForm = true;
        //   this.showMsg = false;

        //   // if(this.adMaterialData.creative_array == null){
        //   //   this.adMaterialData.creative_array = [
        //   //     {
        //   //       title: "xxxx",
        //   //       isEdit: false,
        //   //       type: 1,
        //   //       materials:[],
        //   //       materialSingle: [
        //   //         {
        //   //           src: null,
        //   //           title: null,
        //   //           size: null
        //   //         }
        //   //       ],
        //   //       callActive: 'SIGN_UP'
        //   //     }
        //   //   ]
        //   // }
        // }
        // if(value == 'MESSAGES'){
        //   this.showMaterial = true;
        //   // this.showAdvertisingMaterial = false;
        //   this.showForm = false;
        //   // this.showMsg = false;

        //   // if(this.adMaterialData.creative_array == null){
        //   //   this.adMaterialData.creative_array = [
        //   //     {
        //   //       title: "xxxx",
        //   //       isEdit: false,
        //   //       type: 1,
        //   //       materials:[],
        //   //       materialSingle: [
        //   //         {
        //   //           src: null,
        //   //           title: null,
        //   //           size: null
        //   //         }
        //   //       ],
        //   //       callActive: 'SIGN_UP'
        //   //     }
        //   //   ]
        //   // }
        // }

        // if(value == 'PRODUCT_CATALOG_SALES'){
        //   this.showMaterial = true;
        //   this.showAdvertisingMaterial = false;
        //   this.showForm = false;
        //   this.showMsg = false;

        //   this.postData.select_article = [];
        //   this.postData.select_creatives = [];

        //   console.log('is PRODUCT_CATALOG_SALES');
        // } else {
        //   this.postData.select_creatives_adset_ads = [];

        //   console.log('not PRODUCT_CATALOG_SALES');
        // }

        // console.log(this.postData);

        this.adMaterialDataNew = this.tmpAdMaterialDataNew

        // console.log('this.showMaterial:'+this.showMaterial);
        // console.log('this.showAdvertisingMaterial:'+this.showAdvertisingMaterial);
        // console.log('this.showForm:'+this.showForm);
        // console.log('this.showMsg:'+this.showMsg);

        // console.log('this.adMaterialData');
        // console.log(this.adMaterialData);
      },
      objectiveOption(value){
        if(value != '' && value != null && typeof value != 'undefined'){
          let objectiveOptionValue = value.split("|");

          // console.log('objectiveOption');
          // console.log(objectiveOptionValue);
          // console.log(this.formPixelId);

          this.formPixelId = objectiveOptionValue[0]

          // console.log(this.formPixelId);
        }
      },
      keywordUrl(value){
        // console.log('keywordUrl')
        // console.log(value);

        this.productUrl = value
      },
      childSelectedCategories(value){
        this.keywordsSelectedCategories = value;
      },
      childReturnKeywords(value){
        this.returnKeywordsList = value;
      },
      childNoTiktok(value){
        this.noTiktokStatus = value;
      },
      getHere(target){
        this.changeYoutubeType();

        this.target = target

        // if(this.menu[1].show == false){
        //   if (target > 1) {
        //     target -= 1
        //   }
        //   this.process = parseInt(33) * (parseInt(target) - parseInt(1))
        // } else {
        //   this.process = parseInt(25) * (parseInt(target) - parseInt(1))
        // }

        this.process = parseInt(33) * (parseInt(target) - parseInt(1))

        document.getElementById('edit_content').scrollTop = 0;
      },
      eventPageId(value) {
        // console.log('methods eventPageId')
        // console.log(value);
        this.formPageId = value
      },
      eventFormId(value) {
        console.log('methods eventFormId')
        console.log(value);

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = value+'_'+yearForm + monthForm + dateForm + timeForm;
        if(value != '' && value != null && typeof value != 'undefined'){
          this.formId = get_value
        } else {
          this.formId = []
        }
      },
      eventMessageId(value) {
        console.log('methods eventMessageId')
        console.log(value);

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = value+'_'+yearForm + monthForm + dateForm + timeForm;
        if(value != '' && value != null && typeof value != 'undefined'){
          this.messageId = get_value
        } else {
          this.messageId = []
        }
      },
      adMaterialContent(value){
        // console.log('adMaterialContent')
        // console.log(value);

        if(typeof value.creative_array != 'undefined'){
          this.adMaterialDataNew = value
        } else {
          this.adMaterialDataNew.creative_array = value
        }
      },
      formChangeFormId(value){
        console.log('b this.changeFormId')
        console.log(this.changeFormId);

        console.log('value')
        console.log(value);

        // this.changeFormId = null

        // console.log('c this.changeFormId')
        // console.log(this.changeFormId);

        this.changeFormId = value

        console.log('a this.changeFormId')
        console.log(this.changeFormId);
      },
      formChangeMessageId(value){
        // console.log('formChangeMessageId')
        // console.log(value);

        this.changeMessageId = value
      },
      activeScroll(value){
        let tmpDataType = value.split('_');

        if(tmpDataType[0] == 1){
          this.showAdvertisingMaterial = true;
          this.showMsg = true;

          this.AdvertisingMaterialStatus = this.showMsg;

          // this.$refs.scrollcontent.scrollTo({
          //   top: 1505,
          //   behavior: 'smooth'
          // });
        }
      },
      prev() {
        // console.log('now target:'+this.target);
        let isTrue = 1;

        this.changeYoutubeType();

        if(this.target == 2){
          // console.log('risk_level:'+this.goalsData.risk_level.code);
          // console.log('effect:'+this.goalsData.effect);
          if((this.goalsData.risk_level.code == 'auto' || this.goalsData.risk_level.code == 'low') && (this.goalsData.effect == '' || this.goalsData.effect == 0 || this.goalsData.effect == null)){
            Swal.fire(
                      this.showLang[this.selectLang]['views']['Event']['methods']['prev']['empty_effect_swal_title'],
                      this.showLang[this.selectLang]['views']['Event']['methods']['prev']['empty_effect_swal_text'],
                      "warning"
                    )

            isTrue = 0;
          }
        }

        if(isTrue == 1){
          // if(this.menu[1].show == false){
            this.process -= 33
            if (this.target > 1) {
              this.target -= 1

              // if(this.target == 2){
              //   this.target -= 1
              // }
            }
          // } else {
          //   this.process -= 25
          //   if (this.target > 1) {
          //     this.target -= 1
          //   }
          // }
          // console.log('prev target:'+this.target);

          document.getElementById('edit_content').scrollTop = 0;
        }
      },
      next() {
        // console.log('now target:'+this.target);
        let isTrue = 1;

        this.changeYoutubeType();

        if(this.target == 2){
          // console.log('risk_level:'+this.goalsData.risk_level.code);
          // console.log('effect:'+this.goalsData.effect);
          if((this.goalsData.risk_level.code == 'auto' || this.goalsData.risk_level.code == 'low') && (this.goalsData.effect == '' || this.goalsData.effect == 0 || this.goalsData.effect == null)){
            Swal.fire(
                      this.showLang[this.selectLang]['views']['Event']['methods']['next']['empty_effect_swal_title'],
                      this.showLang[this.selectLang]['views']['Event']['methods']['next']['empty_effect_swal_text'],
                      "warning"
                    )

            isTrue = 0;
          }

          let event_text = this.showLang[this.selectLang]['views']['Event']['methods']['next']['product_datalog_sales_default_event_text'];
          if(this.goalsData.campaign_objective == 'PRODUCT_CATALOG_SALES'){
            event_text = this.showLang[this.selectLang]['views']['Event']['methods']['next']['is_product_datalog_sales_default_event_text'];
          }

          if(this.goalsData.objective_option == '' || this.goalsData.objective_option == null || typeof this.goalsData.objective_option == 'undefined'){
            Swal.fire(
                      this.showLang[this.selectLang]['views']['Event']['methods']['next']['empty_product_catalog_sales_swal_title'],
                      event_text,
                      "warning"
                    )

            isTrue = 0;
          }

          if(this.goalsData.campaign_objective == 'PRODUCT_CATALOG_SALES'){
            if(this.goalsData.product_set_id == '' || this.goalsData.product_set_id == null || typeof this.goalsData.product_set_id == 'undefined'){
              Swal.fire(
                        this.showLang[this.selectLang]['views']['Event']['methods']['next']['empty_product_catalog_sales_swal_title'],
                        this.showLang[this.selectLang]['views']['Event']['methods']['next']['is_product_datalog_sales_set_id_event_text'],
                        "warning"
                      )

              isTrue = 0;
            }

            if(this.goalsData.product_catalog_id == '' || this.goalsData.product_catalog_id == null || typeof this.goalsData.product_catalog_id == 'undefined'){
              Swal.fire(
                        this.showLang[this.selectLang]['views']['Event']['methods']['next']['empty_product_catalog_sales_swal_title'],
                        this.showLang[this.selectLang]['views']['Event']['methods']['next']['is_product_datalog_sales_catalog_id_event_text'],
                        "warning"
                      )

              isTrue = 0;
            }
          }
        }

        if(isTrue == 1){
          // console.log('next target:'+this.target);
          if(this.target >= 3){
            // console.log('儲存並發佈');
            this.release();
          }

          // if(this.menu[1].show == false){
            if(this.process < 66){
              this.process += 33
              // console.log('now target:'+this.target);
              if (this.target <= 3) {
                this.target += 1
                this.menu[this.target-1].open = true
              }
              // if(this.target == 2){
              //   this.target += 1
              // }
            }
          // } else {
          //   if(this.process < 75){
          //     this.process += 25
          //     // console.log('now target:'+this.target);
          //     if (this.target <= 4) {
          //       this.target += 1
          //       this.menu[this.target-1].open = true
          //     }
          //     // console.log('next target:'+this.target);
          //   }
          //   // console.log('next target:'+this.target);
          // }
          // console.log('next target:'+this.target);

          document.getElementById('edit_content').scrollTop = 0;
        }
      },
      form_update(){
        // let _this = this;
        // console.log('form_update');
        // this.testa().then(function(result){
        //   _this.id = result;
        //   console.log('form update is:'+_this.id);
        // });;
        // console.log('testa 跑完了');
        // this.testb();
        // console.log('testb 跑完了');
        let isTrue = 1;

        // this.changeYoutubeType();

        if(isTrue == 1){
          let member_hash = this.$route.params.id
          let adaccount_id = this.$route.params.adaccount_id

          axios
            .post('https://test.autoturn.net/inside/api/campaign_member_status.php', Qs.stringify({
              s_code: member_hash,
              route_type: this.$route.params.type,
              active: 'member',
            }))
            .then((caResponse) => {

              if(caResponse.data.status == 'error'){
                if(caResponse.data.type == 2){
                  Swal.fire({
                    icon: caResponse.data.status,
                    title: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['error']['swal_title'],
                    text: caResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['error']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                    }
                  })
                } else if(caResponse.data.type == 3){
                  Swal.fire({
                    icon: caResponse.data.status,
                    title: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['error']['swal_title'],
                    text: caResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['error']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/t/"+member_hash;
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/t/"+member_hash;
                    }
                  })
                } else {
                  Swal.fire(
                            this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['error']['swal_title'],
                            caResponse.data.info,
                            caResponse.data.status
                          )
                }
              }

              if(caResponse.data.status == 'warning'){
                Swal.fire({
                  icon: 'warning',
                  title: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  var daily_keyword_split_budget = this.methodData.Budget_KW;
                  var daily_demo_budget = this.methodData.Budget_DM;
                  var budget_addition = this.goalsData.form_addition;

                  if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                      var d1 = new Date(this.dateData.start_date);
                      var d2 = new Date(this.dateData.end_date);
                      var days = parseInt((d2-d1)/86400000) + parseInt(1);
                  } else {
                      var days = 0;
                  }

                  var keyword_split_budget = 0;
                  if(this.methodData.Budget_KW != ''){
                      keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                  }

                  var demo_budget = 0;
                  if(this.methodData.Budget_DM != ''){
                      demo_budget = this.methodData.Budget_DM * days;
                  }

                  var _tmp_audience_budget = 0;
                  var audience_budget = 0;
                  if(this.methodData.Budget_LA != ''){
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                    _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                    // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));
                  }

                  var _tmp_marketing_again_budget = 0;
                  var marketing_again_budget = 0;
                  if(this.methodData.Budget_RT != ''){
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                    _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                    // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));
                  }

                  // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                  var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

                  if(isNaN(html)){
                      html = '0';
                  }

                  this.total_budget = html;

                  let _tmp_goalsData = this.goalsData;
                  const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                  let _tmp_exAudiencesData = this.exAudiencesData;
                  const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                  // console.log(_tmp_exAudiencesData);

                  delete _view_goalsData['objective_list'];
                  delete _view_exAudiencesData['custom_excluded_audiences'];

                  let formData = {
                    campaign_id: this.campaign_id,
                    campaign_name: this.campaign_name,
                    advertiser_id: this.advertiser_id,
                    Budget_KW_result: this.Budget_KW_result,
                    total_budget: this.total_budget,
                    methodData: this.methodData,
                    dateData: this.dateData,
                    keywordData: this.keywordData,
                    lookData: this.lookData,
                    goalsData: _view_goalsData,
                    regionsData: this.regionsData,
                    selectCountries: this.selectCountries,
                    selectLangs: this.selectLangs,
                    exAudiencesData: _view_exAudiencesData,
                    pdData: this.pdData,
                    idData: this.idData,
                    postData: this.postData,
                    adMaterialData: this.adMaterialDataNew
                  }

                  // console.log('a this.adMaterialDataNew');
                  // console.log(this.adMaterialDataNew);

                  if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
                    // console.log('#1');
                    let materialType = 0;
                    let selectArticleLength = 0;
                    if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
                      selectArticleLength = this.postData.select_article.length;
                    }

                    let selectCreativesMessageLength = 0;
                    if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
                      selectCreativesMessageLength = this.postData.select_creatives_message.length;
                    }

                    let creativeArrayLength = 0;
                    if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
                      creativeArrayLength = this.adMaterialDataNew.creative_array.length;
                    }

                    if(creativeArrayLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                      materialType = 1;
                    } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
                      materialType = 2;
                    }

                    console.log('#1 materialType:'+materialType);

                    if(materialType == 0){
                      // console.log('#2');
                      // let message_sr_i = 0;
                      // let form_sr_i = 0;
                      // let message = 0;
                      // let single_object_spec = 0;
                      // let single_title = 0;
                      // let materials_item = 0;
                      // let materials_object_spec = 0;
                      // let materials_title = 0;
                      // let ad_name = 0;

                      // for(let i = 0; i < this.adMaterialDataNew.creative_array.length; i++){
                      //   if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
                      //     ad_name = 1;
                      //   }

                      //   if(this.adMaterialDataNew.creative_array[i].type == 2){
                      //     let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

                      //     if(materials_length < 2){
                      //       materials_item = 1;
                      //     } else {
                      //       for(let j = 0; j < materials_length; j++){
                      //         if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
                      //           materials_object_spec = 1;
                      //         }

                      //         if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
                      //           materials_title = 1;
                      //         }
                      //       }
                      //     }
                      //   }

                      //   if(this.adMaterialDataNew.creative_array[i].type == 1){
                      //     if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
                      //       single_object_spec = 1;
                      //     }

                      //     if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
                      //       single_title = 1;
                      //     }
                      //   }

                      //   if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
                      //     message = 1;
                      //   }

                      //   if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
                      //     form_sr_i = 1;
                      //   }

                      //   if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
                      //     message_sr_i = 1;
                      //   }
                      // }

                      // if(ad_name == 1){
                      //   Swal.fire(
                      //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                      //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['not_ad_name_swal_text'],
                      //               "error"
                      //             )
                      // } else if(single_object_spec == 1){
                      //   Swal.fire(
                      //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                      //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['not_single_object_spec_swal_text'],
                      //               "error"
                      //             )
                      // } else if(single_title == 1){
                      //   Swal.fire(
                      //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                      //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['not_single_title_swal_text'],
                      //               "error"
                      //             )
                      // } else if(materials_item == 1){
                      //   Swal.fire(
                      //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                      //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['not_materials_item_swal_text'],
                      //               "error"
                      //             )
                      // } else if(materials_object_spec == 1){
                      //   Swal.fire(
                      //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                      //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['not_materials_object_spec_swal_text'],
                      //               "error"
                      //             )
                      // } else if(materials_title == 1){
                      //   Swal.fire(
                      //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                      //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['not_materials_title_swal_text'],
                      //               "error"
                      //             )
                      // } else if(message == 1){
                      //   Swal.fire(
                      //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                      //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['not_message_swal_text'],
                      //               "error"
                      //             )
                      // } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                      //   Swal.fire(
                      //             this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                      //             this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['not_form_sr_i_swal_text'],
                      //             "error"
                      //           )
                      // } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
                      //   Swal.fire(
                      //             this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                      //             this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['not_message_sr_i_swal_text'],
                      //             "error"
                      //           )
                      // } else {
                        // console.log('#5');
                        axios
                          .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            form_data: formData,
                            type: 'finish',
                            target: 'edit_update_'+this.target,
                          }))
                          .then((response) => {
                            // console.log(response.data);
                            if(response.data.status == 'success'){
                              // this.immediateList = response.data.return_data
                              // this.formData = response.data.return_data.form

                              Swal.fire({
                                icon: 'success',
                                title: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['update_swal_title'],
                                text: response.data.info,
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['update_confirm_button'],
                                // denyButtonText: `Don't save`,
                              }).then((result) => {
                                /* Read more about isConfirmed, isDenied below */
                                if (result.isConfirmed) {
                                  // Swal.fire('Saved!', '', 'success')

                                  window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                                } else if (result.isDenied) {
                                  // Swal.fire('Changes are not saved', '', 'info')
                                }
                              })

                              // if(type == 1){
                              //   var todayForm = new Date();
                              //   var yearForm = todayForm.getFullYear();
                              //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                              //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                              //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                              //   todayForm = yearForm + monthForm + dateForm + timeForm;

                              //   this.formTitle = 'title_'+todayForm;
                              // } else {
                              //   this.formTitle = response.data.return_data.name;
                              // }

                              // this.showModal = true
                            } else {
                              let text = this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_default_swal_text'];
                              if(response.data.info != '' && response.data.info != null){
                                text = response.data.info
                              }
                              Swal.fire(
                                this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_swal_title'],
                                text,
                                'error'
                              )
                            }
                          });
                      // }
                    } else {
                      // console.log('#3');
                      Swal.fire(
                                  this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['not_creative_array_swal_title'],
                                  this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['not_creative_array_swal_text'],
                                  "error"
                                )
                    }
                  } else {
                    // console.log('#4');
                    axios
                      .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        form_data: formData,
                        type: 'finish',
                        target: 'edit_update_'+this.target,
                      }))
                      .then((response) => {
                        // console.log(response.data);
                        if(response.data.status == 'success'){
                          // this.immediateList = response.data.return_data
                          // this.formData = response.data.return_data.form

                          Swal.fire({
                            icon: 'success',
                            title: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['campaign_update']['success']['swal_title'],
                            text: response.data.info,
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['campaign_update']['success']['confirm_button'],
                            // denyButtonText: `Don't save`,
                          }).then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            if (result.isConfirmed) {
                              // Swal.fire('Saved!', '', 'success')

                              window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                            } else if (result.isDenied) {
                              // Swal.fire('Changes are not saved', '', 'info')
                            }
                          })

                          // if(type == 1){
                          //   var todayForm = new Date();
                          //   var yearForm = todayForm.getFullYear();
                          //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                          //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                          //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                          //   todayForm = yearForm + monthForm + dateForm + timeForm;

                          //   this.formTitle = 'title_'+todayForm;
                          // } else {
                          //   this.formTitle = response.data.return_data.name;
                          // }

                          // this.showModal = true
                        } else {
                          let text = this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['campaign_update']['not_success']['default_swal_text'];
                          if(response.data.info != '' && response.data.info != null){
                            text = response.data.info
                          }
                          Swal.fire(
                            this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['campaign_update']['not_success']['swal_title'],
                            text,
                            'error'
                          )
                        }
                      });
                  }
                });
              }

              if(caResponse.data.status == 'success'){
                var daily_keyword_split_budget = this.methodData.Budget_KW;
                var daily_demo_budget = this.methodData.Budget_DM;
                var budget_addition = this.goalsData.form_addition;

                if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                    var d1 = new Date(this.dateData.start_date);
                    var d2 = new Date(this.dateData.end_date);
                    var days = parseInt((d2-d1)/86400000) + parseInt(1);
                } else {
                    var days = 0;
                }

                var keyword_split_budget = 0;
                if(this.methodData.Budget_KW != ''){
                    keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                }

                var demo_budget = 0;
                if(this.methodData.Budget_DM != ''){
                    demo_budget = this.methodData.Budget_DM * days;
                }

                var _tmp_audience_budget = 0;
                var audience_budget = 0;
                if(this.methodData.Budget_LA != ''){
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                  _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                  // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));
                }

                var _tmp_marketing_again_budget = 0;
                var marketing_again_budget = 0;
                if(this.methodData.Budget_RT != ''){
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                  _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                  // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));
                }

                // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

                if(isNaN(html)){
                    html = '0';
                }

                this.total_budget = html;

                console.log('20220930');

                let _tmp_goalsData = this.goalsData;
                const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                let _tmp_exAudiencesData = this.exAudiencesData;
                const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                // console.log(_tmp_exAudiencesData);

                delete _view_goalsData['objective_list'];
                delete _view_exAudiencesData['custom_excluded_audiences'];

                let formData = {
                  campaign_id: this.campaign_id,
                  campaign_name: this.campaign_name,
                  advertiser_id: this.advertiser_id,
                  Budget_KW_result: this.Budget_KW_result,
                  total_budget: this.total_budget,
                  methodData: this.methodData,
                  dateData: this.dateData,
                  keywordData: this.keywordData,
                  lookData: this.lookData,
                  goalsData: _view_goalsData,
                  regionsData: this.regionsData,
                  selectCountries: this.selectCountries,
                  selectLangs: this.selectLangs,
                  exAudiencesData: _view_exAudiencesData,
                  pdData: this.pdData,
                  idData: this.idData,
                  postData: this.postData,
                  adMaterialData: this.adMaterialDataNew
                }

                // console.log('b this.adMaterialDataNew');
                // console.log(this.adMaterialDataNew);

                if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
                  // console.log('#1');
                  let materialType = 0;
                  let selectArticleLength = 0;
                  if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
                    selectArticleLength = this.postData.select_article.length;
                  }

                  let selectCreativesMessageLength = 0;
                  if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
                    selectCreativesMessageLength = this.postData.select_creatives_message.length;
                  }

                  let creativeArrayLength = 0;
                  if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
                    creativeArrayLength = this.adMaterialDataNew.creative_array.length;
                  }

                  if(creativeArrayLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                    materialType = 1;
                  } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
                    materialType = 2;
                  }

                  console.log('#2 materialType:'+materialType);

                  if(materialType == 0){
                    // console.log('#2');
                    // let message_sr_i = 0;
                    // let form_sr_i = 0;
                    // let message = 0;
                    // let single_object_spec = 0;
                    // let single_title = 0;
                    // let materials_item = 0;
                    // let materials_object_spec = 0;
                    // let materials_title = 0;
                    // let ad_name = 0;

                    // for(let i = 0; i < this.adMaterialDataNew.creative_array.length; i++){
                    //   if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
                    //     ad_name = 1;
                    //   }

                    //   if(this.adMaterialDataNew.creative_array[i].type == 2){
                    //     let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

                    //     if(materials_length < 2){
                    //       materials_item = 1;
                    //     } else {
                    //       for(let j = 0; j < materials_length; j++){
                    //         if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
                    //           materials_object_spec = 1;
                    //         }

                    //         if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
                    //           materials_title = 1;
                    //         }
                    //       }
                    //     }
                    //   }

                    //   if(this.adMaterialDataNew.creative_array[i].type == 1){
                    //     if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
                    //       single_object_spec = 1;
                    //     }

                    //     if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
                    //       single_title = 1;
                    //     }
                    //   }

                    //   if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
                    //     message = 1;
                    //   }

                    //   if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
                    //     form_sr_i = 1;
                    //   }

                    //   if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
                    //     message_sr_i = 1;
                    //   }
                    // }

                    // if(ad_name == 1){
                    //   Swal.fire(
                    //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                    //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['not_ad_name_swal_text'],
                    //               "error"
                    //             )
                    // } else if(single_object_spec == 1){
                    //   Swal.fire(
                    //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                    //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['not_single_object_spec_swal_text'],
                    //               "error"
                    //             )
                    // } else if(single_title == 1){
                    //   Swal.fire(
                    //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                    //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['not_single_title_swal_text'],
                    //               "error"
                    //             )
                    // } else if(materials_item == 1){
                    //   Swal.fire(
                    //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                    //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['not_materials_item_swal_text'],
                    //               "error"
                    //             )
                    // } else if(materials_object_spec == 1){
                    //   Swal.fire(
                    //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                    //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['not_materials_object_spec_swal_text'],
                    //               "error"
                    //             )
                    // } else if(materials_title == 1){
                    //   Swal.fire(
                    //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                    //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['not_materials_title_swal_text'],
                    //               "error"
                    //             )
                    // } else if(message == 1){
                    //   Swal.fire(
                    //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                    //               this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['not_message_swal_text'],
                    //               "error"
                    //             )
                    // } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                    //   Swal.fire(
                    //             this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                    //             this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['not_form_sr_i_swal_text'],
                    //             "error"
                    //           )
                    // } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
                    //   Swal.fire(
                    //             this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                    //             this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['not_message_sr_i_swal_text'],
                    //             "error"
                    //           )
                    // } else {
                      // console.log('#5');
                      axios
                        .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          form_data: formData,
                          type: 'finish',
                          target: 'edit_update_'+this.target,
                        }))
                        .then((response) => {
                          // console.log(response.data);
                          if(response.data.status == 'success'){
                            // this.immediateList = response.data.return_data
                            // this.formData = response.data.return_data.form

                            Swal.fire({
                              icon: 'success',
                              title: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['update_swal_title'],
                              text: response.data.info,
                              showDenyButton: false,
                              showCancelButton: false,
                              confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['update_confirm_button'],
                              // denyButtonText: `Don't save`,
                            }).then((result) => {
                              /* Read more about isConfirmed, isDenied below */
                              if (result.isConfirmed) {
                                // Swal.fire('Saved!', '', 'success')

                                window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                              } else if (result.isDenied) {
                                // Swal.fire('Changes are not saved', '', 'info')
                              }
                            })

                            // if(type == 1){
                            //   var todayForm = new Date();
                            //   var yearForm = todayForm.getFullYear();
                            //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                            //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                            //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                            //   todayForm = yearForm + monthForm + dateForm + timeForm;

                            //   this.formTitle = 'title_'+todayForm;
                            // } else {
                            //   this.formTitle = response.data.return_data.name;
                            // }

                            // this.showModal = true
                          } else {
                            let text = this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['update_not_success_default_swal_text'];
                            if(response.data.info != '' && response.data.info != null){
                              text = response.data.info
                            }
                            Swal.fire(
                              this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['update_not_success_swal_title'],
                              text,
                              'error'
                            )
                          }
                        });
                    // }
                  } else {
                    // console.log('#3');
                    Swal.fire(
                                this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['not_creative_array_swal_title'],
                                this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['not_creative_array_swal_text'],
                                "error"
                              )
                  }
                } else {
                  // console.log('#4');
                  axios
                    .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                      s_code: this.$route.params.id,
                      form_data: formData,
                      type: 'finish',
                      target: 'edit_update_'+this.target,
                    }))
                    .then((response) => {
                      // console.log(response.data);
                      if(response.data.status == 'success'){
                        // this.immediateList = response.data.return_data
                        // this.formData = response.data.return_data.form

                        Swal.fire({
                          icon: 'success',
                          title: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['campaign_update']['success']['swal_title'],
                          text: response.data.info,
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['campaign_update']['success']['confirm_button'],
                          // denyButtonText: `Don't save`,
                        }).then((result) => {
                          /* Read more about isConfirmed, isDenied below */
                          if (result.isConfirmed) {
                            // Swal.fire('Saved!', '', 'success')

                            window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                          } else if (result.isDenied) {
                            // Swal.fire('Changes are not saved', '', 'info')
                          }
                        })

                        // if(type == 1){
                        //   var todayForm = new Date();
                        //   var yearForm = todayForm.getFullYear();
                        //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                        //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                        //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                        //   todayForm = yearForm + monthForm + dateForm + timeForm;

                        //   this.formTitle = 'title_'+todayForm;
                        // } else {
                        //   this.formTitle = response.data.return_data.name;
                        // }

                        // this.showModal = true
                      } else {
                        let text = this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['campaign_update']['not_success']['default_swal_text'];
                        if(response.data.info != '' && response.data.info != null){
                          text = response.data.info
                        }
                        Swal.fire(
                          this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['campaign_update']['not_success']['swal_title'],
                          text,
                          'error'
                        )
                      }
                    });
                }
              }

              if(caResponse.data.status == 'login'){
                Swal.fire({
                  icon: 'error',
                  title: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['login']['swal_title'],
                  text: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['login']['swal_text'],
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['login']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    // Swal.fire('Saved!', '', 'success')
                    // this.allPageLoading = true
                    window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                  } else if (result.isDenied) {
                    // Swal.fire('Changes are not saved', '', 'info')
                    // this.allPageLoading = true
                    window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                  }
                })
              }
            });
        }
      },
      release(){
        let isTrue = 1;

        // this.changeYoutubeType();

        if(this.advertiser_id == null || this.advertiser_id == '' || typeof this.advertiser_id == 'undefined'){
          // console.log('#1');
          Swal.fire({
            icon: 'error',
            title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_adaccount_id_swal_title'],
            text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_adaccount_id_swal_text'],
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText:  this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_adaccount_id_swal_confirm_button']
          }).then((result) => {
            if (result.isConfirmed) {
              this.allPageLoading = true
              window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id;
            } else if (result.isDenied) {
              this.allPageLoading = true
              window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id;
            }
          })

          isTrue = 0;
        }

        if(this.campaign_name == null || this.campaign_name == '' || typeof this.campaign_name == 'undefined'){
          // console.log('#2');
          Swal.fire(
                        this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_campaign_name_swal_title'],
                        this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_campaign_name_swal_text'],
                        "error"
                      )
          isTrue = 0;
        }

        // if(this.methodData.Target_KW == false && this.methodData.Target_DM == false && this.methodData.Target_LA == false && this.methodData.Target_RT == false && this.methodData.Target_AD == false){
        //   // console.log('#3');
        //   Swal.fire(
        //             this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_marketing_target_swal_title'],
        //             this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_marketing_target_swal_text'],
        //             "error"
        //           )
        //   isTrue = 0;
        // }

        if(this.methodData.Budget_KW == ''){
          // console.log('#4');
          Swal.fire(
                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_marketing_budget_swal_title'],
                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_marketing_budget_swal_text'],
                    "error"
                  )
          isTrue = 0;
        }

        // if(this.methodData.Target_RT == true && (this.methodData.retargeting == '' || this.methodData.retargeting == [])){
        //   Swal.fire(
        //             '行銷方式-再行銷',
        //             '請勾選任一種要投遞的行銷方式。',
        //             "error"
        //           )
        //   isTrue = 0;
        // }

        // if(this.methodData.Target_AD == true){
        //   if(this.methodData.Budget_AD_min != '' && this.methodData.Budget_AD_min != null && typeof this.methodData.Budget_AD_min != 'undefined' && this.methodData.Budget_AD_max != '' && this.methodData.Budget_AD_max != null && typeof this.methodData.Budget_AD_max != 'undefined' && parseInt(this.methodData.Budget_AD_min) >= parseInt(this.methodData.Budget_AD_max)){

        //     Swal.fire(
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_title'],
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_text_1'],
        //               "error"
        //             )

        //     isTrue = 0;
        //   }

        //   if(parseInt(this.methodData.Budget_AD_min) == 0 || this.methodData.Budget_AD_min == '' || this.methodData.Budget_AD_min == null || typeof this.methodData.Budget_AD_min == 'undefined'){
        //     Swal.fire(
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_title'],
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_text_2'],
        //               "error"
        //             )

        //     isTrue = 0;
        //   }

        //   if(parseInt(this.methodData.Budget_AD_max) == 0 || this.methodData.Budget_AD_max == '' || this.methodData.Budget_AD_max == null || typeof this.methodData.Budget_AD_max == 'undefined'){
        //     Swal.fire(
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_title'],
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_text_3'],
        //               "error"
        //             )

        //     isTrue = 0;
        //   }
        // }

        let creator_action_categories_length = this.keywordData.creator_action_categories.length;
        let interest_categories_length = this.keywordData.interest_categories.length;
        let video_action_categories_length = this.keywordData.video_action_categories.length;
        let interest_keywords_length = this.keywordData.interest_keywords.length;
        let hashtags_length = this.keywordData.hashtags.length;
        let select_keywords_num = 0;

        select_keywords_num = parseInt(creator_action_categories_length) + parseInt(interest_categories_length) +parseInt(video_action_categories_length) + parseInt(interest_keywords_length) + parseInt(hashtags_length);

        if(select_keywords_num != 5){
          console.log('11');
          Swal.fire(
                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_select_keywords_swal_title'],
                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_select_keywords_swal_text'],
                  "error"
                )
          isTrue = 0;
        }

        if(this.dateData.start_date != '' && this.dateData.start_date != '0000-00-00' && this.dateData.end_date != '' && this.dateData.end_date != '0000-00-00'){
          // console.log('#5');
          let startTime = this.dateData.start_date;
          let endTime = this.dateData.end_date;

          var sTime = new Date(startTime); //開始時間
          var eTime = new Date(endTime); //結束時間

          if(sTime > eTime){
            Swal.fire(
                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_start_date_swal_title'],
                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_start_date_swal_text'],
                      "error"
                    )
            isTrue = 0;
          }
        }

        // console.log(this.dateData.end_date+':'+this.dateData.use_end_date);

        if(this.dateData.end_date == '0000-00-00' && (this.dateData.use_end_date == false || typeof this.dateData.use_end_date == 'undefined')){
          // console.log('#6');
          Swal.fire(
                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_end_date_swal_title'],
                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_end_date_swal_text'],
                    "error"
                  )
          isTrue = 0;
        }

        // if(this.methodData.Target_KW == true){
        //   if(this.keywordData.select_keywords != '' && this.keywordData.select_keywords != null && typeof this.keywordData.select_keywords != 'undefined'){
        //     // console.log('#7');
        //     if(this.keywordData.select_keywords.length > 0 && this.methodData.Target_KW == true){
        //       let select_keywords_num = 0;
        //       for (var i = 0; i >= this.keywordData.select_keywords.length; i++) {
        //         if(this.keywordData.select_keywords.checked == true){
        //           select_keywords_num = parseInt(select_keywords_num) + parseInt(1);
        //         }
        //       }

        //       if(select_keywords_num > 5){
        //         // console.log('11');
        //         Swal.fire(
        //                 this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_select_keywords_swal_title'],
        //                 this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_select_keywords_swal_text'],
        //                 "error"
        //               )
        //         isTrue = 0;
        //       }
        //     }
        //   } else {
        //     // console.log('22');
        //     Swal.fire(
        //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_select_keywords_swal_title'],
        //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_select_keywords_swal_text'],
        //               "error"
        //             )
        //     isTrue = 0;
        //   }
        // }

        // if(this.methodData.Target_LA == true){
        //   // console.log('#8');
        //   // console.log('this.lookData.default_lookalikes_list');
        //   // console.log(this.lookData.default_lookalikes_list);
        //   // console.log('this.lookData.custom_lookalikes_selected');
        //   // console.log(this.lookData.custom_lookalikes_selected);
        //   // console.log('this.lookData.custom_lookalikes_selected.length');
        //   // console.log(this.lookData.custom_lookalikes_selected.length);
        //   if((this.lookData.default_lookalikes_list != '' && this.lookData.default_lookalikes_list != null && typeof this.lookData.default_lookalikes_list != 'undefined') || (this.lookData.custom_lookalikes_selected != '' && this.lookData.custom_lookalikes_selected != null && typeof this.lookData.custom_lookalikes_selected != 'undefined')){
        //     let lookalikes_num = 0;
        //     if(this.lookData.default_lookalikes_list.length > 0){
        //       for (var i = 0; i < this.lookData.default_lookalikes_list.length; i++) {
        //         // console.log('i1:'+i);
        //         if(this.lookData.default_lookalikes_list[i].checked == true){
        //           lookalikes_num = parseInt(lookalikes_num) + parseInt(1);
        //         }
        //       }
        //     }

        //     if(this.lookData.custom_lookalikes_selected.length > 0){
        //       for (var i = 0; i < this.lookData.custom_lookalikes_selected.length; i++) {
        //         // console.log('i2:'+i);
        //         lookalikes_num = parseInt(lookalikes_num) + parseInt(1);
        //       }
        //     }

        //     if(lookalikes_num != 5){
        //       // console.log('33');
        //       Swal.fire(
        //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_lookalikes_selected_swal_title'],
        //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_lookalikes_selected_swal_text'],
        //               "error"
        //             )
        //       isTrue = 0;
        //     }
        //   } else {
        //     // console.log('44');
        //     Swal.fire(
        //             this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_lookalikes_selected_swal_title'],
        //             this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_lookalikes_selected_swal_text'],
        //             "error"
        //           )
        //     isTrue = 0;
        //   }
        // }

        // console.log('this.goalsData');
        // console.log(this.goalsData);
        // console.log('objective_option:'+this.goalsData.objective_option);
        // console.log('conversion_domain:'+this.goalsData.conversion_domain);
        // console.log('risk_level:'+this.goalsData.risk_level.code);
        // console.log('excluded_audiences:'+this.exAudiencesData.excluded_audiences);
        if(this.goalsData.objective_option == '' || this.goalsData.objective_option == null || typeof this.goalsData.objective_option == 'undefined'){
          // console.log('#9');
          Swal.fire(
                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_objective_option_swal_title'],
                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_objective_option_swal_text'],
                  "error"
                )
          isTrue = 0;
        }

        if(this.goalsData.effect == '' || this.goalsData.effect == 0 || this.goalsData.effect == null){
          Swal.fire(
                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_effect_swal_title'],
                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_effect_swal_text'],
                    "error"
                  )

          isTrue = 0;
        }

        console.log('this.regionsData');
        console.log(this.regionsData);

        if(this.regionsData.locations_selected == '' || this.regionsData.locations_selected == 0 || this.regionsData.locations_selected == null){
          // console.log('#2');
          Swal.fire(
                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_locations_swal_title'],
                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_locations_swal_text'],
                    "error"
                  )
          isTrue = 0;
        }

        if(this.regionsData.age_groups.length <= 0){
          Swal.fire(
                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_age_groups_swal_title'],
                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_age_groups_swal_text'],
                    "error"
                  )

          isTrue = 0;
        }

        if(this.pdData.placement_type == 'PLACEMENT_TYPE_NORMAL'){
          if(this.pdData.placements != null && this.pdData.placements != '' && typeof this.pdData.placements != 'undefined'){
            if(this.pdData.placements.length <= 0){
              Swal.fire(
                        this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_placements_swal_title'],
                        this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_placements_swal_text'],
                        "error"
                      )

              isTrue = 0;
            }
          } else {
            Swal.fire(
                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_placements_swal_title'],
                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_placements_swal_text'],
                      "error"
                    )

            isTrue = 0;
          }
        }

        if(this.idData.identity_id == '' || this.idData.identity_id == 0 || this.idData.identity_id == null){
          Swal.fire(
                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_identity_id_swal_title'],
                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_identity_id_swal_text'],
                    "error"
                  )

          isTrue = 0;
        }

        let caption_format = 0;
        let caption = 0;
        let message = 0;
        let single_object_spec = 0;
        let title = 0;

        console.log('this.adMaterialData');
        console.log(this.adMaterialData);
        console.log('this.adMaterialDataNew');
        console.log(this.adMaterialDataNew);

        let creative_array_length = this.adMaterialDataNew.creative_array.length;
        console.log(creative_array_length);

        if(creative_array_length > 0){
          for(let i = 0; i < creative_array_length; i++){
            console.log(this.adMaterialDataNew.creative_array[i].caption);
            const regex = /^(http:\/\/|https:\/\/)/;

            if (!regex.test(this.adMaterialDataNew.creative_array[i].caption)) {
              caption_format = 1;
            }

            if(this.adMaterialDataNew.creative_array[i].caption == '' || this.adMaterialDataNew.creative_array[i].caption == null || typeof this.adMaterialDataNew.creative_array[i].caption == 'undefined'){
              caption = 1;
            }

            console.log(this.adMaterialDataNew.creative_array[i].message);

            if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
              message = 1;
            }

            console.log(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id);

            if(this.adMaterialDataNew.creative_array[i].type == 1){
              if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.video_id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.video_id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.video_id == 'undefined'){
                single_object_spec = 1;
              }
            }

            console.log(this.adMaterialDataNew.creative_array[i].title);

            if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
              title = 1;
            }
          }

          if(caption_format == 1){
            isTrue = 0;

            Swal.fire(
              this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_material_caption_swal_title'],
              this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_material_caption_format_swal_text'],
              'error'
            );
          }

          if(caption == 1){
            isTrue = 0;

            Swal.fire(
              this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_material_caption_swal_title'],
              this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_material_caption_swal_text'],
              'error'
            );
          }

          if(message == 1){
            isTrue = 0;

            Swal.fire(
              this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_material_message_swal_title'],
              this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_material_message_swal_text'],
              'error'
            );
          }

          if(single_object_spec == 1){
            isTrue = 0;

            Swal.fire(
              this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_material_single_object_spec_swal_title'],
              this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_material_single_object_spec_swal_text'],
              'error'
            );
          }

          if(title == 1){
            isTrue = 0;

            Swal.fire(
              this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_material_title_swal_title'],
              this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_material_title_swal_text'],
              'error'
            );
          }
        } else {
          isTrue = 0;

          Swal.fire(
            this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_material_creative_array_length_swal_title'],
            this.showLang[this.selectLang]['views']['Event']['methods']['release']['empty_material_creative_array_length_swal_text'],
            'error'
          );
        }

        // if(this.goalsData.campaign_objective == 'CONVERSIONS' && (this.goalsData.conversion_domain == '' || this.goalsData.conversion_domain == null || typeof this.goalsData.conversion_domain == 'undefined')){
        //   // console.log('#10');
        //   Swal.fire(
        //             this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_conversion_domain_swal_title'],
        //             this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_conversion_domain_swal_text'],
        //             "error"
        //           )
        //   isTrue = 0;
        // }

        ////////////////////////////////////////

        // if(this.methodData.Target_AD == true){
        //   if(this.goalsData.effect == '' || this.goalsData.effect == null || typeof this.goalsData.effect == 'undefined'){
        //     Swal.fire(
        //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['efficient_ai_not_effect_swal_title'],
        //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['efficient_ai_not_effect_swal_text'],
        //               "error"
        //             )

        //     isTrue = 0;
        //   }

        //   console.log('this.methodData.Budget_AD_min');
        //   console.log(this.methodData.Budget_AD_min);
        //   console.log('typeof this.methodData.Budget_AD_min');
        //   console.log(typeof this.methodData.Budget_AD_min);
        //   console.log('this.methodData.Budget_AD_max');
        //   console.log(this.methodData.Budget_AD_max);
        //   console.log('typeof this.methodData.Budget_AD_max');
        //   console.log(typeof this.methodData.Budget_AD_max);

        //   if(this.methodData.Budget_AD_min != '' && this.methodData.Budget_AD_min != null && typeof this.methodData.Budget_AD_min != 'undefined' && this.methodData.Budget_AD_max != '' && this.methodData.Budget_AD_max != null && typeof this.methodData.Budget_AD_max != 'undefined' && parseInt(this.methodData.Budget_AD_min) >= parseInt(this.methodData.Budget_AD_max)){

        //     Swal.fire(
        //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['efficient_ai_swal_title'],
        //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['efficient_ai_swal_text_1'],
        //               "error"
        //             )

        //     isTrue = 0;
        //   }

        //   if(parseInt(this.methodData.Budget_AD_min) == 0 || this.methodData.Budget_AD_min == '' || this.methodData.Budget_AD_min == null || typeof this.methodData.Budget_AD_min == 'undefined'){
        //     Swal.fire(
        //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['efficient_ai_swal_title'],
        //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['efficient_ai_swal_text_2'],
        //               "error"
        //             )

        //     isTrue = 0;
        //   }

        //   if(parseInt(this.methodData.Budget_AD_max) == 0 || this.methodData.Budget_AD_max == '' || this.methodData.Budget_AD_max == null || typeof this.methodData.Budget_AD_max == 'undefined'){
        //     Swal.fire(
        //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['efficient_ai_swal_title'],
        //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['efficient_ai_swal_text_3'],
        //               "error"
        //             )

        //     isTrue = 0;
        //   }
        // }

        // if((this.goalsData.risk_level.code == 'auto' || this.goalsData.risk_level.code == 'low') && (this.goalsData.effect == '' || this.goalsData.effect == 0 || this.goalsData.effect == null)){
        //   // console.log('#11');
        //   Swal.fire(
        //             this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_effect_swal_title'],
        //             this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_effect_swal_text'],
        //             "error"
        //           )

        //   isTrue = 0;
        // }

        ////////////////////////////////////////

        // if(this.methodData.Target_AD == true){
        //   let _default_Budget_AD_max = Math.trunc(parseInt(this.goalsData.effect) * parseInt(10));
        //   console.log('_default_Budget_AD_max');
        //   console.log(_default_Budget_AD_max);
        //   console.log('this.methodData.Budget_AD_max');
        //   console.log(this.methodData.Budget_AD_max);
        //   if(_default_Budget_AD_max > this.methodData.Budget_AD_max){
        //     Swal.fire(
        //               '目標成本',
        //               '預算上限要大於目標成本 10 倍。',
        //               "error"
        //             )

        //     isTrue = 0;
        //   }
        // }

        // if(this.exAudiencesData.excluded_audiences != '' && this.exAudiencesData.excluded_audiences != null && typeof this.exAudiencesData.excluded_audiences != 'undefined' ){
        //   // console.log('#12');
        //   let excluded_audiences = this.exAudiencesData.excluded_audiences.length;
        //   // console.log(excluded_audiences);
        //   // console.log(this.exAudiencesData.custom_excluded_audiences_selected.length);
        //   let custom_excluded_audiences_selected_num = 0;
        //   if(this.exAudiencesData.custom_excluded_audiences_selected.length > 0){
        //     for (var i = 0; i >= this.exAudiencesData.custom_excluded_audiences_selected.length; i++) {
        //       if(this.exAudiencesData.custom_excluded_audiences_selected.checked == true){
        //         custom_excluded_audiences_selected_num = parseInt(custom_excluded_audiences_selected_num) + parseInt(1);
        //       }
        //     }
        //   }

        //   let excluded_audiences_num = parseInt(excluded_audiences) + parseInt(custom_excluded_audiences_selected_num);

        //   if(excluded_audiences_num > 10){
        //     Swal.fire(
        //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_excluded_audiences_swal_title'],
        //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_excluded_audiences_swal_text'],
        //               "error"
        //             )

        //     isTrue = 0;
        //   }
        // }

        // let selectArticleLength = 0;
        // if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
        //   selectArticleLength = this.postData.select_article.length;
        // }

        // let selectCreativesLength = 0;
        // if(this.postData.select_creatives != '' && this.postData.select_creatives != null && typeof this.postData.select_creatives != 'undefined'){
        //   selectCreativesLength = this.postData.select_creatives.length;
        // }

        // let creativeArrayLength = 0;
        // if(this.postData.select_creatives_adset_ads != '' && this.postData.select_creatives_adset_ads != null && typeof this.postData.select_creatives_adset_ads != 'undefined'){
        //   creativeArrayLength = this.postData.select_creatives_adset_ads.length;
        // }

        // let numMaterial = parseInt(selectArticleLength) + parseInt(selectCreativesLength) + parseInt(creativeArrayLength);
        // let _default_Budget_AD_mim = parseInt(numMaterial) * parseInt(this.goalsData.effect);
        // if(parseInt(this.methodData.Budget_AD_min) < _default_Budget_AD_mim){
        //   Swal.fire(
        //             '素材設定',
        //             '預算下限要大於 '+_default_Budget_AD_mim,
        //             "error"
        //           )

        //   isTrue = 0;
        // }

        if(isTrue == 1){
          // console.log('#13');
          let member_hash = this.$route.params.id
          let adaccount_id = this.$route.params.adaccount_id

          console.log(adaccount_id);

          axios
            .post('https://test.autoturn.net/inside/api/campaign_member_status.php', Qs.stringify({
              s_code: member_hash,
              route_type: this.$route.params.type,
              active: 'release',
            }))
            .then((caResponse) => {

              if(caResponse.data.status == 'error'){
                // console.log('#14');
                if(caResponse.data.type == 2){
                  Swal.fire({
                    icon: caResponse.data.status,
                    title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['swal_title'],
                    text: caResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                    }
                  })
                } else if(caResponse.data.type == 3){
                  Swal.fire({
                    icon: caResponse.data.status,
                    title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['swal_title'],
                    text: caResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/t/"+member_hash;
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/t/"+member_hash;
                    }
                  })
                } else {
                  Swal.fire(
                            this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['swal_title'],
                            caResponse.data.info,
                            caResponse.data.status
                          )
                }
              }

              if(caResponse.data.status == 'warning'){
                // console.log('#15');
                Swal.fire({
                  icon: 'warning',
                  title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  var daily_keyword_split_budget = this.methodData.Budget_KW;
                  var daily_demo_budget = this.methodData.Budget_DM;
                  var budget_addition = this.goalsData.form_addition;

                  if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                      var d1 = new Date(this.dateData.start_date);
                      var d2 = new Date(this.dateData.end_date);
                      var days = parseInt((d2-d1)/86400000) + parseInt(1);
                  } else {
                      var days = 0;
                  }

                  var keyword_split_budget = 0;
                  if(this.methodData.Budget_KW != ''){
                      keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                  }

                  var demo_budget = 0;
                  if(this.methodData.Budget_DM != ''){
                      demo_budget = this.methodData.Budget_DM * days;
                  }

                  var _tmp_audience_budget = 0;
                  var audience_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                  _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                  // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                  var _tmp_marketing_again_budget = 0;
                  var marketing_again_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                  _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                  // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                  // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                  var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

                  if(isNaN(html)){
                      html = '0';
                  }

                  this.total_budget = html;

                  let _tmp_goalsData = this.goalsData;
                  const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                  let _tmp_exAudiencesData = this.exAudiencesData;
                  const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                  // console.log(_tmp_exAudiencesData);

                  delete _view_goalsData['objective_list'];
                  delete _view_exAudiencesData['custom_excluded_audiences'];

                  let formData = {
                    campaign_id: this.campaign_id,
                    campaign_name: this.campaign_name,
                    advertiser_id: this.advertiser_id,
                    Budget_KW_result: this.Budget_KW_result,
                    total_budget: this.total_budget,
                    methodData: this.methodData,
                    dateData: this.dateData,
                    keywordData: this.keywordData,
                    lookData: this.lookData,
                    goalsData: _view_goalsData,
                    regionsData: this.regionsData,
                    selectCountries: this.selectCountries,
                    selectLangs: this.selectLangs,
                    exAudiencesData: _view_exAudiencesData,
                    pdData: this.pdData,
                    idData: this.idData,
                    postData: this.postData,
                    adMaterialData: this.adMaterialDataNew
                  }

                  if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
                    // console.log('#1');
                    let materialType = 0;
                    let selectArticleLength = 0;
                    if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
                      selectArticleLength = this.postData.select_article.length;
                    }

                    let selectCreativesMessageLength = 0;
                    if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
                      selectCreativesMessageLength = this.postData.select_creatives_message.length;
                    }

                    let creativeArrayLength = 0;
                    if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
                      creativeArrayLength = this.adMaterialDataNew.creative_array.length;
                    }                 

                    if(creativeArrayLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                      materialType = 1;
                    } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
                      materialType = 2;
                    }

                    console.log('#3 materialType:'+materialType);

                    if(materialType == 0){
                      // console.log('#2');
                      let message_sr_i = 0;
                      let form_sr_i = 0;
                      let message = 0;
                      let single_object_spec = 0;
                      let single_title = 0;
                      let materials_item = 0;
                      let materials_object_spec = 0;
                      let materials_title = 0;
                      let ad_name = 0;

                      for(let i = 0; i < this.adMaterialDataNew.creative_array.length; i++){
                        if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
                          ad_name = 1;
                        }

                        if(this.adMaterialDataNew.creative_array[i].type == 2){
                          let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

                          if(materials_length < 2){
                            materials_item = 1;
                          } else {
                            for(let j = 0; j < materials_length; j++){
                              if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
                                materials_object_spec = 1;
                              }

                              if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
                                materials_title = 1;
                              }
                            }
                          }
                        }

                        if(this.adMaterialDataNew.creative_array[i].type == 1){
                          if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
                            single_object_spec = 1;
                          }

                          if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
                            single_title = 1;
                          }
                        }

                        if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
                          message = 1;
                        }

                        if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
                          form_sr_i = 1;
                        }

                        if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
                          message_sr_i = 1;
                        }
                      }

                      if(ad_name == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_ad_name_swal_text'],
                                    "error"
                                  )
                      } else if(single_object_spec == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_single_object_spec_swal_text'],
                                    "error"
                                  )
                      } else if(single_title == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_single_title_swal_text'],
                                    "error"
                                  )
                      } else if(materials_item == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_materials_item_swal_text'],
                                    "error"
                                  )
                      } else if(materials_object_spec == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_materials_object_spec_swal_text'],
                                    "error"
                                  )
                      } else if(materials_title == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_materials_title_swal_text'],
                                    "error"
                                  )
                      } else if(message == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_message_swal_text'],
                                    "error"
                                  )
                      } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                        Swal.fire(
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_form_sr_i_swal_text'],
                                  "error"
                                )
                      } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
                        Swal.fire(
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_message_sr_i_swal_text'],
                                  "error"
                                )
                      } else {
                        // console.log('#5');
                        axios
                          .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            form_data: formData,
                            type: 'release',
                            target: 'edit_release_'+this.target,
                          }))
                          .then((response) => {
                            // console.log(response.data);
                            if(response.data.status == 'success'){
                              // console.log('#16');
                              // this.immediateList = response.data.return_data
                              // this.formData = response.data.return_data.form

                              if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                                let name = this.campaign_name;
                                let currency = this.currencyData.currency;
                                let addition = this.goalsData.budget_increase;
                                let daily_budget = this.methodData.Budget_KW;
                                // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                // if(addition == '' || addition == 0){
                                //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                // }

                                let addition_text = '（'+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                                if(this.methodData.Target_AD == true){
                                  addition_text = '';
                                }
                                let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                                let campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
                                if(this.dateData.end_date != '0000-00-00'){
                                  two_week_budget = this.total_budget;
                                  campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
                                }

                                Swal.fire({
                                  // title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
                                  title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_title'],
                                  html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_c'],
                                  icon: 'warning',
                                  showCancelButton: true,
                                  confirmButtonColor: '#3085d6',
                                  cancelButtonColor: '#d33',
                                  confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['yes_button'],
                                  cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['no_button'],
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    // console.log(this.$route.params.id);

                                    this.releaseType = true
                                    this.style = 'z-index:100;';
                                    this.releasePercent = 5;
                                    let status = 1;
                                    let num = 0;
                                    let member_hash = this.$route.params.id;
                                    var bar5 = new ldBar("#myItem5");
                                    bar5.set(this.releasePercent);

                                    axios
                                      .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_release.php', Qs.stringify({
                                        s_code: member_hash,
                                        campaign_id: this.campaign_id,
                                      }))
                                      .then((caResponse) => {
                                        // console.log('caResponse:'+caResponse.data.return_data);
                                        if(caResponse.data.status == 'success'){
                                          // console.log('#17');
                                          //進行進度條
                                          // console.log('發佈莞成，開始跑進度條');
                                          setInterval( () => {
                                            num++;
                                            if(num < 1200){
                                              // console.log('num:'+num);
                                              // console.log(this.releaseType);

                                              if(this.releaseType == true){
                                                axios
                                                  .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_states.php', Qs.stringify({
                                                    s_code: member_hash,
                                                    adaccount_id: this.advertiser_id,
                                                    campaign_id: this.campaign_id,
                                                  }))
                                                  .then((csResponse) => {
                                                    // console.log('csResponse:'+csResponse.data.return_data);
                                                    //進行進度條
                                                    if(status == 1){
                                                      if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                        this.releaseType = false
                                                        this.style = 'z-index:-1;';
                                                        bar5.set(0);
                                                        status = 0;
                                                        // Swal.fire({
                                                        //   icon: 'error',
                                                        //   title: '正式發佈',
                                                        //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                        //   showDenyButton: false,
                                                        //   showCancelButton: false,
                                                        //   confirmButtonText: '確定',
                                                        //   timer: 5000
                                                        //   // denyButtonText: `Don't save`,
                                                        // }).then((result) => {
                                                        //   /* Read more about isConfirmed, isDenied below */
                                                        //   if (result.isConfirmed) {
                                                        //     // Swal.fire('Saved!', '', 'success')
                                                        //     this.allPageLoading = true
                                                        //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                        //   } else if (result.isDenied) {
                                                        //     // Swal.fire('Changes are not saved', '', 'info')
                                                        //     this.allPageLoading = true
                                                        //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                        //   }

                                                        //   if (result.dismiss === Swal.DismissReason.timer) {
                                                        //     this.allPageLoading = true
                                                        //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                        //   }
                                                        // })
                                                        Swal.fire({
                                                          icon: 'error',
                                                          title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
                                                          text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                          showDenyButton: false,
                                                          showCancelButton: false,
                                                          confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
                                                        }).then((result) => {

                                                        })
                                                      } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                                        status = 0;

                                                        axios
                                                          .post('https://test.autoturn.net/inside/api/data/campaign_creative_optimize_update.php', Qs.stringify({
                                                            s_code: member_hash,
                                                            id: this.campaign_id,
                                                          }))
                                                          .then((response) => {
                                                            axios
                                                              .get('https://test.autoturn.net/inside/udnapi/public/send_notice_email.php?s_code='+member_hash+'&s_code='+member_hash+'&form=release&sr_i='+this.campaign_id)
                                                              .then((csResponse) => {
                                                                this.releaseType = false

                                                                Swal.fire({
                                                                  icon: 'success',
                                                                  title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
                                                                  text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
                                                                  showDenyButton: false,
                                                                  showCancelButton: false,
                                                                  confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                                                                  timer: 5000
                                                                  // denyButtonText: `Don't save`,
                                                                }).then((result) => {
                                                                  /* Read more about isConfirmed, isDenied below */
                                                                  if (result.isConfirmed) {
                                                                    // Swal.fire('Saved!', '', 'success')
                                                                    this.allPageLoading = true
                                                                    window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                                  } else if (result.isDenied) {
                                                                    // Swal.fire('Changes are not saved', '', 'info')
                                                                    this.allPageLoading = true
                                                                    window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                                  }

                                                                  if (result.dismiss === Swal.DismissReason.timer) {
                                                                    this.allPageLoading = true
                                                                    window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                                  }
                                                                })
                                                              });
                                                          });
                                                      } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                        this.releaseType = false
                                                        this.style = 'z-index:-1;';
                                                        bar5.set(0);
                                                        status = 0;
                                                        // Swal.fire({
                                                        //   icon: 'error',
                                                        //   title: '正式發佈',
                                                        //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                        //   showDenyButton: false,
                                                        //   showCancelButton: false,
                                                        //   confirmButtonText: '確定',
                                                        //   timer: 5000
                                                        //   // denyButtonText: `Don't save`,
                                                        // }).then((result) => {
                                                        //   /* Read more about isConfirmed, isDenied below */
                                                        //   if (result.isConfirmed) {
                                                        //     // Swal.fire('Saved!', '', 'success')
                                                        //     this.allPageLoading = true
                                                        //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                        //   } else if (result.isDenied) {
                                                        //     // Swal.fire('Changes are not saved', '', 'info')
                                                        //     this.allPageLoading = true
                                                        //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                        //   }

                                                        //   if (result.dismiss === Swal.DismissReason.timer) {
                                                        //     this.allPageLoading = true
                                                        //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                        //   }
                                                        // })
                                                        Swal.fire({
                                                          icon: 'error',
                                                          title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
                                                          text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                          showDenyButton: false,
                                                          showCancelButton: false,
                                                          confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
                                                        }).then((result) => {

                                                        })
                                                      } else {
                                                        this.releaseText = csResponse.data.return_data.info_text
                                                        this.releasePercent = csResponse.data.return_data.info_pct

                                                        bar5.set(this.releasePercent);
                                                        // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                                        // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                                        // console.log('this.releaseText:'+this.releaseText);
                                                        // console.log('this.releasePercent:'+this.releasePercent);

                                                        if(csResponse.data.return_data.info_pct == 100){
                                                          this.releaseType = false
                                                          this.style = 'z-index:-1;';
                                                          bar5.set(0);
                                                          status = 0;
                                                        }
                                                      }
                                                    }
                                                  });
                                              }
                                            } else {
                                              Swal.fire({
                                                icon: 'warning',
                                                title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['else']['swal_title'],
                                                text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['else']['swal_html'],
                                                showDenyButton: false,
                                                showCancelButton: false,
                                                confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['else']['confirm_button'],
                                                timer: 1000
                                                // denyButtonText: `Don't save`,
                                              }).then((result) => {
                                                /* Read more about isConfirmed, isDenied below */
                                                if (result.isConfirmed) {
                                                  // Swal.fire('Saved!', '', 'success')
                                                  this.allPageLoading = true
                                                  window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                } else if (result.isDenied) {
                                                  // Swal.fire('Changes are not saved', '', 'info')
                                                  this.allPageLoading = true
                                                  window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                }

                                                if (result.dismiss === Swal.DismissReason.timer) {
                                                  this.allPageLoading = true
                                                  window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                }
                                              })
                                            }
                                          }, 3000);
                                        }
                                      });
                                  }
                                })
                              } else {
                                Swal.fire(
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['not_success']['swal_title'],
                                  response.data.info,
                                  'error'
                                )
                              }

                              // if(type == 1){
                              //   var todayForm = new Date();
                              //   var yearForm = todayForm.getFullYear();
                              //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                              //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                              //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                              //   todayForm = yearForm + monthForm + dateForm + timeForm;

                              //   this.formTitle = 'title_'+todayForm;
                              // } else {
                              //   this.formTitle = response.data.return_data.name;
                              // }

                              // this.showModal = true
                            } else {
                              let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_default_swal_text'];
                              if(response.data.info != '' && response.data.info != null){
                                text = response.data.info
                              }
                              Swal.fire(
                                this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_swal_title'],
                                text,
                                'error'
                              )
                            }
                          });
                      }
                    } else {
                      // console.log('#3');
                      Swal.fire(
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_creative_array_swal_title'],
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_creative_array_swal_text'],
                                  "error"
                                )
                    }
                  } else {
                    axios
                      .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        form_data: formData,
                        type: 'release',
                        target: 'edit_release_'+this.target,
                      }))
                      .then((response) => {
                        // console.log(response.data);
                        if(response.data.status == 'success'){
                          // console.log('#16');
                          // this.immediateList = response.data.return_data
                          // this.formData = response.data.return_data.form

                          if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                            let name = this.campaign_name;
                            let currency = this.currencyData.currency;
                            let addition = this.goalsData.budget_increase;
                            let daily_budget = this.methodData.Budget_KW;
                            // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                            // if(addition == '' || addition == 0){
                            //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                            // }

                            let addition_text = '（'+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                            if(this.methodData.Target_AD == true){
                              addition_text = '';
                            }
                            let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                            let campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
                            if(this.dateData.end_date != '0000-00-00'){
                              two_week_budget = this.total_budget;
                              campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
                            }

                            Swal.fire({
                              // title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
                              title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_title'],
                              html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_c'],
                              icon: 'warning',
                              showCancelButton: true,
                              confirmButtonColor: '#3085d6',
                              cancelButtonColor: '#d33',
                              confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['yes_button'],
                              cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['no_button'],
                            }).then((result) => {
                              if (result.isConfirmed) {
                                // console.log(this.$route.params.id);

                                this.releaseType = true
                                this.style = 'z-index:100;';
                                this.releasePercent = 5;
                                let status = 1;
                                let num = 0;
                                let member_hash = this.$route.params.id;
                                var bar5 = new ldBar("#myItem5");
                                bar5.set(this.releasePercent);

                                axios
                                  .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_release.php', Qs.stringify({
                                    s_code: member_hash,
                                    campaign_id: this.campaign_id,
                                  }))
                                  .then((caResponse) => {
                                    // console.log('caResponse:'+caResponse.data.return_data);
                                    if(caResponse.data.status == 'success'){
                                      // console.log('#17');
                                      //進行進度條
                                      // console.log('發佈莞成，開始跑進度條');
                                      setInterval( () => {
                                        num++;
                                        if(num < 1200){
                                          // console.log('num:'+num);
                                          // console.log(this.releaseType);

                                          if(this.releaseType == true){
                                            axios
                                              .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_states.php', Qs.stringify({
                                                s_code: member_hash,
                                                adaccount_id: this.advertiser_id,
                                                campaign_id: this.campaign_id,
                                              }))
                                              .then((csResponse) => {
                                                // console.log('csResponse:'+csResponse.data.return_data);
                                                //進行進度條
                                                if(status == 1){
                                                  if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                    this.releaseType = false
                                                    this.style = 'z-index:-1;';
                                                    bar5.set(0);
                                                    status = 0;
                                                    // Swal.fire({
                                                    //   icon: 'error',
                                                    //   title: '正式發佈',
                                                    //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                    //   showDenyButton: false,
                                                    //   showCancelButton: false,
                                                    //   confirmButtonText: '確定',
                                                    //   timer: 5000
                                                    //   // denyButtonText: `Don't save`,
                                                    // }).then((result) => {
                                                    //   /* Read more about isConfirmed, isDenied below */
                                                    //   if (result.isConfirmed) {
                                                    //     // Swal.fire('Saved!', '', 'success')
                                                    //     this.allPageLoading = true
                                                    //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                    //   } else if (result.isDenied) {
                                                    //     // Swal.fire('Changes are not saved', '', 'info')
                                                    //     this.allPageLoading = true
                                                    //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                    //   }

                                                    //   if (result.dismiss === Swal.DismissReason.timer) {
                                                    //     this.allPageLoading = true
                                                    //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                    //   }
                                                    // })
                                                    Swal.fire({
                                                      icon: 'error',
                                                      title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
                                                      text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                      showDenyButton: false,
                                                      showCancelButton: false,
                                                      confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
                                                    }).then((result) => {

                                                    })
                                                  } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                                    status = 0;

                                                    axios
                                                      .post('https://test.autoturn.net/inside/api/data/campaign_creative_optimize_update.php', Qs.stringify({
                                                        s_code: member_hash,
                                                        id: this.campaign_id,
                                                      }))
                                                      .then((response) => {
                                                        axios
                                                          .get('https://test.autoturn.net/inside/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.campaign_id)
                                                          .then((csResponse) => {
                                                            this.releaseType = false

                                                            Swal.fire({
                                                              icon: 'success',
                                                              title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
                                                              text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
                                                              showDenyButton: false,
                                                              showCancelButton: false,
                                                              confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                                                              timer: 5000
                                                              // denyButtonText: `Don't save`,
                                                            }).then((result) => {
                                                              /* Read more about isConfirmed, isDenied below */
                                                              if (result.isConfirmed) {
                                                                // Swal.fire('Saved!', '', 'success')
                                                                this.allPageLoading = true
                                                                window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                              } else if (result.isDenied) {
                                                                // Swal.fire('Changes are not saved', '', 'info')
                                                                this.allPageLoading = true
                                                                window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                              }

                                                              if (result.dismiss === Swal.DismissReason.timer) {
                                                                this.allPageLoading = true
                                                                window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                              }
                                                            })
                                                          });
                                                      });
                                                  } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                    this.releaseType = false
                                                    this.style = 'z-index:-1;';
                                                    bar5.set(0);
                                                    status = 0;
                                                    // Swal.fire({
                                                    //   icon: 'error',
                                                    //   title: '正式發佈',
                                                    //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                    //   showDenyButton: false,
                                                    //   showCancelButton: false,
                                                    //   confirmButtonText: '確定',
                                                    //   timer: 5000
                                                    //   // denyButtonText: `Don't save`,
                                                    // }).then((result) => {
                                                    //   /* Read more about isConfirmed, isDenied below */
                                                    //   if (result.isConfirmed) {
                                                    //     // Swal.fire('Saved!', '', 'success')
                                                    //     this.allPageLoading = true
                                                    //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                    //   } else if (result.isDenied) {
                                                    //     // Swal.fire('Changes are not saved', '', 'info')
                                                    //     this.allPageLoading = true
                                                    //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                    //   }

                                                    //   if (result.dismiss === Swal.DismissReason.timer) {
                                                    //     this.allPageLoading = true
                                                    //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                    //   }
                                                    // })
                                                    Swal.fire({
                                                      icon: 'error',
                                                      title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
                                                      text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                      showDenyButton: false,
                                                      showCancelButton: false,
                                                      confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
                                                    }).then((result) => {

                                                    })
                                                  } else {
                                                    this.releaseText = csResponse.data.return_data.info_text
                                                    this.releasePercent = csResponse.data.return_data.info_pct

                                                    bar5.set(this.releasePercent);
                                                    // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                                    // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                                    // console.log('this.releaseText:'+this.releaseText);
                                                    // console.log('this.releasePercent:'+this.releasePercent);

                                                    if(csResponse.data.return_data.info_pct == 100){
                                                      this.releaseType = false
                                                      this.style = 'z-index:-1;';
                                                      bar5.set(0);
                                                      status = 0;
                                                    }
                                                  }
                                                }
                                              });
                                          }
                                        } else {
                                          Swal.fire({
                                            icon: 'warning',
                                            title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['else']['swal_title'],
                                            text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['else']['swal_html'],
                                            showDenyButton: false,
                                            showCancelButton: false,
                                            confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['else']['confirm_button'],
                                            timer: 1000
                                            // denyButtonText: `Don't save`,
                                          }).then((result) => {
                                            /* Read more about isConfirmed, isDenied below */
                                            if (result.isConfirmed) {
                                              // Swal.fire('Saved!', '', 'success')
                                              this.allPageLoading = true
                                              window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                            } else if (result.isDenied) {
                                              // Swal.fire('Changes are not saved', '', 'info')
                                              this.allPageLoading = true
                                              window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                            }

                                            if (result.dismiss === Swal.DismissReason.timer) {
                                              this.allPageLoading = true
                                              window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                            }
                                          })
                                        }
                                      }, 3000);
                                    }
                                  });
                              }
                            })
                          } else {
                            Swal.fire(
                              this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
                              response.data.info,
                              'error'
                            )
                          }

                          // if(type == 1){
                          //   var todayForm = new Date();
                          //   var yearForm = todayForm.getFullYear();
                          //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                          //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                          //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                          //   todayForm = yearForm + monthForm + dateForm + timeForm;

                          //   this.formTitle = 'title_'+todayForm;
                          // } else {
                          //   this.formTitle = response.data.return_data.name;
                          // }

                          // this.showModal = true
                        } else {
                          let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['update_not_success_default_swal_text'];
                          if(response.data.info != '' && response.data.info != null){
                            text = response.data.info
                          }
                          Swal.fire(
                            this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['update_not_success_swal_title'],
                            text,
                            'error'
                          )
                        }
                      });
                  }
                });
              }

              if(caResponse.data.status == 'success'){
                // console.log('#18');
                var daily_keyword_split_budget = this.methodData.Budget_KW;
                var daily_demo_budget = this.methodData.Budget_DM;
                var budget_addition = this.goalsData.form_addition;

                if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                    var d1 = new Date(this.dateData.start_date);
                    var d2 = new Date(this.dateData.end_date);
                    var days = parseInt((d2-d1)/86400000) + parseInt(1);
                } else {
                    var days = 0;
                }

                var keyword_split_budget = 0;
                if(this.methodData.Budget_KW != ''){
                    keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                }

                var demo_budget = 0;
                if(this.methodData.Budget_DM != ''){
                    demo_budget = this.methodData.Budget_DM * days;
                }

                var _tmp_audience_budget = 0;
                var audience_budget = 0;
                // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                var _tmp_marketing_again_budget = 0;
                var marketing_again_budget = 0;
                // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

                if(isNaN(html)){
                    html = '0';
                }

                this.total_budget = html;

                let _tmp_goalsData = this.goalsData;
                const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                let _tmp_exAudiencesData = this.exAudiencesData;
                const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                // console.log(_tmp_exAudiencesData);

                delete _view_goalsData['objective_list'];
                delete _view_exAudiencesData['custom_excluded_audiences'];

                let formData = {
                  campaign_id: this.campaign_id,
                  campaign_name: this.campaign_name,
                  advertiser_id: this.advertiser_id,
                  Budget_KW_result: this.Budget_KW_result,
                  total_budget: this.total_budget,
                  methodData: this.methodData,
                  dateData: this.dateData,
                  keywordData: this.keywordData,
                  lookData: this.lookData,
                  goalsData: _view_goalsData,
                  regionsData: this.regionsData,
                  selectCountries: this.selectCountries,
                  selectLangs: this.selectLangs,
                  exAudiencesData: _view_exAudiencesData,
                  pdData: this.pdData,
                  idData: this.idData,
                  postData: this.postData,
                  adMaterialData: this.adMaterialDataNew
                }

                if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
                  // console.log('#1');
                  let materialType = 0;
                  let selectArticleLength = 0;
                  if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
                    selectArticleLength = this.postData.select_article.length;
                  }

                  let selectCreativesMessageLength = 0;
                  if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
                    selectCreativesMessageLength = this.postData.select_creatives_message.length;
                  }

                  let creativeArrayLength = 0;
                  if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
                    creativeArrayLength = this.adMaterialDataNew.creative_array.length;
                  }                 

                  if(creativeArrayLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                    materialType = 1;
                  } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
                    materialType = 2;
                  }

                  console.log('this.postData.select_article');
                  console.log(this.postData.select_article);
                  console.log('this.postData.select_creatives_message');
                  console.log(this.postData.select_creatives_message);
                  console.log('this.adMaterialDataNew.creative_array');
                  console.log(this.adMaterialDataNew.creative_array);
                  console.log('this.goalsData.campaign_objective');
                  console.log(this.goalsData.campaign_objective);
                  console.log(selectArticleLength +' == 0 && '+ selectCreativesMessageLength +' == 0 && '+ creativeArrayLength +' == 0');

                  console.log('#4 materialType:'+materialType);

                  if(materialType == 0){
                    // console.log('#2');
                    let message_sr_i = 0;
                    let form_sr_i = 0;
                    let message = 0;
                    let single_object_spec = 0;
                    let single_title = 0;
                    let materials_item = 0;
                    let materials_object_spec = 0;
                    let materials_title = 0;
                    let ad_name = 0;

                    for(let i = 0; i < this.adMaterialDataNew.creative_array.length; i++){
                      if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
                        ad_name = 1;
                      }

                      if(this.adMaterialDataNew.creative_array[i].type == 2){
                        let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

                        if(materials_length < 2){
                          materials_item = 1;
                        } else {
                          for(let j = 0; j < materials_length; j++){
                            if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
                              materials_object_spec = 1;
                            }

                            if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
                              materials_title = 1;
                            }
                          }
                        }
                      }

                      if(this.adMaterialDataNew.creative_array[i].type == 1){
                        if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
                          single_object_spec = 1;
                        }

                        if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
                          single_title = 1;
                        }
                      }

                      if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
                        message = 1;
                      }

                      if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
                        form_sr_i = 1;
                      }

                      if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
                        message_sr_i = 1;
                      }
                    }

                    if(ad_name == 1){
                      Swal.fire(
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_ad_name_swal_text'],
                                  "error"
                                )
                    } else if(single_object_spec == 1){
                      Swal.fire(
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_single_object_spec_swal_text'],
                                  "error"
                                )
                    } else if(single_title == 1){
                      Swal.fire(
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_single_title_swal_text'],
                                  "error"
                                )
                    } else if(materials_item == 1){
                      Swal.fire(
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_materials_item_swal_text'],
                                  "error"
                                )
                    } else if(materials_object_spec == 1){
                      Swal.fire(
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_materials_object_spec_swal_text'],
                                  "error"
                                )
                    } else if(materials_title == 1){
                      Swal.fire(
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_materials_title_swal_text'],
                                  "error"
                                )
                    } else if(message == 1){
                      Swal.fire(
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_message_swal_text'],
                                  "error"
                                )
                    } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                      Swal.fire(
                                this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                                this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_form_sr_i_swal_text'],
                                "error"
                              )
                    } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
                      Swal.fire(
                                this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                                this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_message_sr_i_swal_text'],
                                "error"
                              )
                    } else {
                      // console.log('#5');
                      axios
                        .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          form_data: formData,
                          type: 'release',
                          target: 'edit_release_'+this.target,
                        }))
                        .then((response) => {
                          // console.log(response.data);
                          if(response.data.status == 'success'){
                            // console.log('#19');
                            // this.immediateList = response.data.return_data
                            // this.formData = response.data.return_data.form

                            if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                              let name = this.campaign_name;
                              let currency = this.currencyData.currency;
                              let addition = this.goalsData.budget_increase;
                              let daily_budget = this.methodData.Budget_KW;
                              // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                              // if(addition == '' || addition == 0){
                              //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                              // }

                              let addition_text = '（'+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['addition_text']+'<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                              if(this.methodData.Target_AD == true){
                                addition_text = '';
                              }
                              let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                              let campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
                              if(this.dateData.end_date != '0000-00-00'){
                                two_week_budget = this.total_budget;
                                campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
                              }

                              Swal.fire({
                                // title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
                                title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_title'],
                                html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_c'],
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['yes_button'],
                                cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['no_button'],
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  // console.log(this.$route.params.id);

                                  this.releaseType = true
                                  this.style = 'z-index:100;';
                                  this.releasePercent = 5;
                                  let status = 1;
                                  let num = 0;
                                  let member_hash = this.$route.params.id;
                                  var bar5 = new ldBar("#myItem5");
                                  bar5.set(this.releasePercent);

                                  axios
                                    .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_release.php', Qs.stringify({
                                      s_code: member_hash,
                                      campaign_id: this.campaign_id,
                                    }))
                                    .then((caResponse) => {
                                      // console.log('caResponse:'+caResponse.data.return_data);
                                      if(caResponse.data.status == 'success'){
                                        // console.log('#20');
                                        //進行進度條
                                        // console.log('發佈莞成，開始跑進度條');
                                        setInterval( () => {
                                          num++;
                                          if(num < 1200){
                                            // console.log('num:'+num);
                                            // console.log(this.releaseType);

                                            if(this.releaseType == true){
                                              axios
                                                .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_states.php', Qs.stringify({
                                                  s_code: member_hash,
                                                  adaccount_id: this.advertiser_id,
                                                  campaign_id: this.campaign_id,
                                                }))
                                                .then((csResponse) => {
                                                  // console.log('csResponse:'+csResponse.data.return_data);
                                                  //進行進度條
                                                  if(status == 1){
                                                    if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                      this.releaseType = false
                                                      this.style = 'z-index:-1;';
                                                      bar5.set(0);
                                                      status = 0;
                                                      // Swal.fire({
                                                      //   icon: 'error',
                                                      //   title: '正式發佈',
                                                      //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                      //   showDenyButton: false,
                                                      //   showCancelButton: false,
                                                      //   confirmButtonText: '確定',
                                                      //   timer: 5000
                                                      //   // denyButtonText: `Don't save`,
                                                      // }).then((result) => {
                                                      //   /* Read more about isConfirmed, isDenied below */
                                                      //   if (result.isConfirmed) {
                                                      //     // Swal.fire('Saved!', '', 'success')
                                                      //     this.allPageLoading = true
                                                      //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                      //   } else if (result.isDenied) {
                                                      //     // Swal.fire('Changes are not saved', '', 'info')
                                                      //     this.allPageLoading = true
                                                      //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                      //   }

                                                      //   if (result.dismiss === Swal.DismissReason.timer) {
                                                      //     this.allPageLoading = true
                                                      //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                      //   }
                                                      // })
                                                      Swal.fire({
                                                        icon: 'error',
                                                        title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
                                                        text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                        showDenyButton: false,
                                                        showCancelButton: false,
                                                        confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
                                                      }).then((result) => {

                                                      })
                                                    } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                                      status = 0;

                                                      axios
                                                        .post('https://test.autoturn.net/inside/api/data/campaign_creative_optimize_update.php', Qs.stringify({
                                                          s_code: member_hash,
                                                          id: this.campaign_id,
                                                        }))
                                                        .then((response) => {
                                                          axios
                                                            .get('https://test.autoturn.net/inside/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.campaign_id)
                                                            .then((csResponse) => {
                                                              this.releaseType = false

                                                              Swal.fire({
                                                                icon: 'success',
                                                                title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
                                                                text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
                                                                showDenyButton: false,
                                                                showCancelButton: false,
                                                                confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                                                                timer: 5000
                                                                // denyButtonText: `Don't save`,
                                                              }).then((result) => {
                                                                /* Read more about isConfirmed, isDenied below */
                                                                if (result.isConfirmed) {
                                                                  // Swal.fire('Saved!', '', 'success')
                                                                  this.allPageLoading = true
                                                                  window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                                } else if (result.isDenied) {
                                                                  // Swal.fire('Changes are not saved', '', 'info')
                                                                  this.allPageLoading = true
                                                                  window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                                }

                                                                if (result.dismiss === Swal.DismissReason.timer) {
                                                                  this.allPageLoading = true
                                                                  window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                                }
                                                              })
                                                            });
                                                        });
                                                    } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                      this.releaseType = false
                                                      this.style = 'z-index:-1;';
                                                      bar5.set(0);
                                                      status = 0;
                                                      // Swal.fire({
                                                      //   icon: 'error',
                                                      //   title: '正式發佈',
                                                      //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                      //   showDenyButton: false,
                                                      //   showCancelButton: false,
                                                      //   confirmButtonText: '確定',
                                                      //   timer: 5000
                                                      //   // denyButtonText: `Don't save`,
                                                      // }).then((result) => {
                                                      //   /* Read more about isConfirmed, isDenied below */
                                                      //   if (result.isConfirmed) {
                                                      //     // Swal.fire('Saved!', '', 'success')
                                                      //     this.allPageLoading = true
                                                      //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                      //   } else if (result.isDenied) {
                                                      //     // Swal.fire('Changes are not saved', '', 'info')
                                                      //     this.allPageLoading = true
                                                      //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                      //   }

                                                      //   if (result.dismiss === Swal.DismissReason.timer) {
                                                      //     this.allPageLoading = true
                                                      //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                      //   }
                                                      // })
                                                      Swal.fire({
                                                        icon: 'error',
                                                        title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
                                                        text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                        showDenyButton: false,
                                                        showCancelButton: false,
                                                        confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
                                                      }).then((result) => {

                                                      })
                                                    } else {
                                                      this.releaseText = csResponse.data.return_data.info_text
                                                      this.releasePercent = csResponse.data.return_data.info_pct

                                                      bar5.set(this.releasePercent);
                                                      // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                                      // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                                      // console.log('this.releaseText:'+this.releaseText);
                                                      // console.log('this.releasePercent:'+this.releasePercent);

                                                      if(csResponse.data.return_data.info_pct == 100){
                                                        this.releaseType = false
                                                        this.style = 'z-index:-1;';
                                                        bar5.set(0);
                                                        status = 0;
                                                      }
                                                    }
                                                  }
                                                });
                                            }
                                          } else {
                                            Swal.fire({
                                              icon: 'warning',
                                              title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['swal_title'],
                                              text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['swal_html'],
                                              showDenyButton: false,
                                              showCancelButton: false,
                                              confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['confirm_button'],
                                              timer: 1000
                                              // denyButtonText: `Don't save`,
                                            }).then((result) => {
                                              /* Read more about isConfirmed, isDenied below */
                                              if (result.isConfirmed) {
                                                // Swal.fire('Saved!', '', 'success')
                                                this.allPageLoading = true
                                                window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                              } else if (result.isDenied) {
                                                // Swal.fire('Changes are not saved', '', 'info')
                                                this.allPageLoading = true
                                                window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                              }

                                              if (result.dismiss === Swal.DismissReason.timer) {
                                                this.allPageLoading = true
                                                window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                              }
                                            })
                                          }
                                        }, 3000);
                                      }
                                    });
                                }
                              })
                            } else {
                              Swal.fire(
                                this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['not_success']['swal_title'],
                                response.data.info,
                                'error'
                              )
                            }

                            // if(type == 1){
                            //   var todayForm = new Date();
                            //   var yearForm = todayForm.getFullYear();
                            //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                            //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                            //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                            //   todayForm = yearForm + monthForm + dateForm + timeForm;

                            //   this.formTitle = 'title_'+todayForm;
                            // } else {
                            //   this.formTitle = response.data.return_data.name;
                            // }

                            // this.showModal = true
                          } else {
                            let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['update_not_success_default_swal_text'];
                            if(response.data.info != '' && response.data.info != null){
                              text = response.data.info
                            }
                            Swal.fire(
                              this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['update_not_success_swal_title'],
                              text,
                              'error'
                            )
                          }
                        });
                    }
                  } else {
                    // console.log('#3');
                    Swal.fire(
                                this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_creative_array_swal_title'],
                                this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_creative_array_swal_text'],
                                "error"
                              )
                  }
                } else {
                  axios
                    .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                      s_code: this.$route.params.id,
                      form_data: formData,
                      type: 'release',
                      target: 'edit_release_'+this.target,
                    }))
                    .then((response) => {
                      // console.log(response.data);
                      if(response.data.status == 'success'){
                        // console.log('#19');
                        // this.immediateList = response.data.return_data
                        // this.formData = response.data.return_data.form

                        if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                          let name = this.campaign_name;
                          let currency = this.currencyData.currency;
                          let addition = this.goalsData.budget_increase;
                          let daily_budget = this.methodData.Budget_KW;
                          // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                          // if(addition == '' || addition == 0){
                          //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                          // }

                          let addition_text = '（'+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                          if(this.methodData.Target_AD == true){
                            addition_text = '';
                          }
                          let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                          let campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
                          if(this.dateData.end_date != '0000-00-00'){
                            two_week_budget = this.total_budget;
                            campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
                          }

                          Swal.fire({
                            // title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
                            title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_title'],
                            html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_c'],
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['yes_button'],
                            cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['no_button'],
                          }).then((result) => {
                            if (result.isConfirmed) {
                              // console.log(this.$route.params.id);

                              this.releaseType = true
                              this.style = 'z-index:100;';
                              this.releasePercent = 5;
                              let status = 1;
                              let num = 0;
                              let member_hash = this.$route.params.id;
                              var bar5 = new ldBar("#myItem5");
                              bar5.set(this.releasePercent);

                              axios
                                .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_release.php', Qs.stringify({
                                  s_code: member_hash,
                                  campaign_id: this.campaign_id,
                                }))
                                .then((caResponse) => {
                                  // console.log('caResponse:'+caResponse.data.return_data);
                                  if(caResponse.data.status == 'success'){
                                    // console.log('#20');
                                    //進行進度條
                                    // console.log('發佈莞成，開始跑進度條');
                                    setInterval( () => {
                                      num++;
                                      if(num < 1200){
                                        // console.log('num:'+num);
                                        // console.log(this.releaseType);

                                        if(this.releaseType == true){
                                          axios
                                            .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_states.php', Qs.stringify({
                                              s_code: member_hash,
                                              adaccount_id: this.advertiser_id,
                                              campaign_id: this.campaign_id,
                                            }))
                                            .then((csResponse) => {
                                              // console.log('csResponse:'+csResponse.data.return_data);
                                              //進行進度條
                                              if(status == 1){
                                                if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                  this.releaseType = false
                                                  this.style = 'z-index:-1;';
                                                  bar5.set(0);
                                                  status = 0;
                                                  // Swal.fire({
                                                  //   icon: 'error',
                                                  //   title: '正式發佈',
                                                  //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                  //   showDenyButton: false,
                                                  //   showCancelButton: false,
                                                  //   confirmButtonText: '確定',
                                                  //   timer: 5000
                                                  //   // denyButtonText: `Don't save`,
                                                  // }).then((result) => {
                                                  //   /* Read more about isConfirmed, isDenied below */
                                                  //   if (result.isConfirmed) {
                                                  //     // Swal.fire('Saved!', '', 'success')
                                                  //     this.allPageLoading = true
                                                  //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                  //   } else if (result.isDenied) {
                                                  //     // Swal.fire('Changes are not saved', '', 'info')
                                                  //     this.allPageLoading = true
                                                  //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                  //   }

                                                  //   if (result.dismiss === Swal.DismissReason.timer) {
                                                  //     this.allPageLoading = true
                                                  //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                  //   }
                                                  // })
                                                  Swal.fire({
                                                    icon: 'error',
                                                    title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
                                                    text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                    showDenyButton: false,
                                                    showCancelButton: false,
                                                    confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
                                                  }).then((result) => {

                                                  })
                                                } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                                  status = 0;

                                                  axios
                                                    .post('https://test.autoturn.net/inside/api/data/campaign_creative_optimize_update.php', Qs.stringify({
                                                      s_code: member_hash,
                                                      id: this.campaign_id,
                                                    }))
                                                    .then((response) => {
                                                      axios
                                                        .get('https://test.autoturn.net/inside/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.campaign_id)
                                                        .then((csResponse) => {
                                                          this.releaseType = false

                                                          Swal.fire({
                                                            icon: 'success',
                                                            title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
                                                            text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
                                                            showDenyButton: false,
                                                            showCancelButton: false,
                                                            confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                                                            timer: 5000
                                                            // denyButtonText: `Don't save`,
                                                          }).then((result) => {
                                                            /* Read more about isConfirmed, isDenied below */
                                                            if (result.isConfirmed) {
                                                              // Swal.fire('Saved!', '', 'success')
                                                              this.allPageLoading = true
                                                              window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                            } else if (result.isDenied) {
                                                              // Swal.fire('Changes are not saved', '', 'info')
                                                              this.allPageLoading = true
                                                              window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                            }

                                                            if (result.dismiss === Swal.DismissReason.timer) {
                                                              this.allPageLoading = true
                                                              window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                            }
                                                          })
                                                        });
                                                    });
                                                } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                  this.releaseType = false
                                                  this.style = 'z-index:-1;';
                                                  bar5.set(0);
                                                  status = 0;
                                                  // Swal.fire({
                                                  //   icon: 'error',
                                                  //   title: '正式發佈',
                                                  //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                  //   showDenyButton: false,
                                                  //   showCancelButton: false,
                                                  //   confirmButtonText: '確定',
                                                  //   timer: 5000
                                                  //   // denyButtonText: `Don't save`,
                                                  // }).then((result) => {
                                                  //   /* Read more about isConfirmed, isDenied below */
                                                  //   if (result.isConfirmed) {
                                                  //     // Swal.fire('Saved!', '', 'success')
                                                  //     this.allPageLoading = true
                                                  //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                  //   } else if (result.isDenied) {
                                                  //     // Swal.fire('Changes are not saved', '', 'info')
                                                  //     this.allPageLoading = true
                                                  //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                  //   }

                                                  //   if (result.dismiss === Swal.DismissReason.timer) {
                                                  //     this.allPageLoading = true
                                                  //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                                  //   }
                                                  // })
                                                  Swal.fire({
                                                    icon: 'error',
                                                    title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
                                                    text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                    showDenyButton: false,
                                                    showCancelButton: false,
                                                    confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
                                                  }).then((result) => {

                                                  })
                                                } else {
                                                  this.releaseText = csResponse.data.return_data.info_text
                                                  this.releasePercent = csResponse.data.return_data.info_pct

                                                  bar5.set(this.releasePercent);
                                                  // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                                  // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                                  // console.log('this.releaseText:'+this.releaseText);
                                                  // console.log('this.releasePercent:'+this.releasePercent);

                                                  if(csResponse.data.return_data.info_pct == 100){
                                                    this.releaseType = false
                                                    this.style = 'z-index:-1;';
                                                    bar5.set(0);
                                                    status = 0;
                                                  }
                                                }
                                              }
                                            });
                                        }
                                      } else {
                                        Swal.fire({
                                          icon: 'warning',
                                          title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['else']['swal_title'],
                                          text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['else']['swal_html'],
                                          showDenyButton: false,
                                          showCancelButton: false,
                                          confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['else']['confirm_button'],
                                          timer: 1000
                                          // denyButtonText: `Don't save`,
                                        }).then((result) => {
                                          /* Read more about isConfirmed, isDenied below */
                                          if (result.isConfirmed) {
                                            // Swal.fire('Saved!', '', 'success')
                                            this.allPageLoading = true
                                            window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                          } else if (result.isDenied) {
                                            // Swal.fire('Changes are not saved', '', 'info')
                                            this.allPageLoading = true
                                            window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                          }

                                          if (result.dismiss === Swal.DismissReason.timer) {
                                            this.allPageLoading = true
                                            window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+adaccount_id;
                                          }
                                        })
                                      }
                                    }, 3000);
                                  }
                                });
                            }
                          })
                        } else {
                          Swal.fire(
                            this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
                            response.data.info,
                            'error'
                          )
                        }

                        // if(type == 1){
                        //   var todayForm = new Date();
                        //   var yearForm = todayForm.getFullYear();
                        //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                        //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                        //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                        //   todayForm = yearForm + monthForm + dateForm + timeForm;

                        //   this.formTitle = 'title_'+todayForm;
                        // } else {
                        //   this.formTitle = response.data.return_data.name;
                        // }

                        // this.showModal = true
                      } else {
                        let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['update_not_success_default_swal_text'];
                        if(response.data.info != '' && response.data.info != null){
                          text = response.data.info
                        }
                        Swal.fire(
                          this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['update_not_success_swal_title'],
                          text,
                          'error'
                        )
                      }
                    });
                }
              }

              if(caResponse.data.status == 'login'){
                Swal.fire({
                  icon: 'error',
                  title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['login']['swal_title'],
                  text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['login']['swal_text'],
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['login']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    // Swal.fire('Saved!', '', 'success')
                    // this.allPageLoading = true
                    window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                  } else if (result.isDenied) {
                    // Swal.fire('Changes are not saved', '', 'info')
                    // this.allPageLoading = true
                    window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                  }
                })
              }
            });
        }
      },
      // async testa (scene) {
      //   console.log('do testa');

      //   return 2;
      // },
      // async testb (scene) {
      //   console.log('do testb');

      //   return 3;
      // }
    },
    mounted () {
      // document.title = '行銷活動修改頁 - AutoTurn';
    }
  }
</script>

<style lang="scss" scope>
  .progressbar {
    background: linear-gradient(270.01deg, #1D619F 0%, #7FDCFA 51.04%, #7AD5C0 76.56%);
    border-radius: 6px;
  }
</style>
